var _defs, _defs2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _use, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _use2, _path224, _path225, _path226, _path227, _use3, _path228, _path229, _path230, _path231, _path232, _use4, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _circle, _circle2, _circle3, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _g, _g2, _path374, _path375, _path376, _path377, _circle4, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _path848, _path849, _path850, _path851, _path852, _path853, _path854, _path855, _path856, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _path878, _path879, _path880, _path881, _path882, _path883, _path884, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _path893, _path894, _path895, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _path904, _path905, _path906, _path907, _path908, _path909, _path910, _path911, _path912, _path913, _path914, _path915, _path916, _path917, _path918, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoatLayout = function SvgBoatLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "boat-layout_svg__tratteggio",
    viewBox: "0 0 922.95 605.78"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-32",
    d: "M365.76 567.12c.46 0 .9-.19 1.22-.52",
    className: "boat-layout_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-157",
    d: "M367.46 526.46v2.26",
    className: "boat-layout_svg__cls-1"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".boat-layout_svg__cls-1{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:.71px}.boat-layout_svg__cls-1,.boat-layout_svg__cls-2,.boat-layout_svg__cls-3{fill:none}.boat-layout_svg__cls-2{isolation:isolate}.boat-layout_svg__cls-4{fill:#b3bbcb}.boat-layout_svg__cls-3{stroke:#85d08e}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE",
    d: "M124.6 518.25h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-2",
    d: "M124.6 504.13h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-3",
    d: "M124.6 490.01h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-4",
    d: "M124.6 475.89h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-5",
    d: "M124.6 461.77h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-6",
    d: "M126.72 447.65h92.48",
    className: "boat-layout_svg__cls-1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-7",
    d: "M124.6 532.37h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-8",
    d: "M124.6 546.49h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-9",
    d: "M124.6 560.61h135.55",
    className: "boat-layout_svg__cls-1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-10",
    d: "M127.6 574.72h87.58",
    className: "boat-layout_svg__cls-1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-11",
    d: "M336.4 470.24h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-12",
    d: "M336.4 467.42h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-13",
    d: "M336.4 464.59h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-14",
    d: "M336.4 461.77h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-15",
    d: "M336.4 453.3h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-16",
    d: "M344.87 453.3h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-17",
    d: "M336.4 450.47h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-18",
    d: "M344.87 450.47h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-19",
    d: "M336.4 447.65h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-20",
    d: "M344.87 447.65h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-21",
    d: "M336.4 444.83h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-22",
    d: "M344.87 444.83h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-23",
    d: "M336.4 442h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-24",
    d: "M344.87 442h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-25",
    d: "M336.4 439.18h7.99",
    className: "boat-layout_svg__cls-1"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-26",
    d: "M336.4 473.06h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-27",
    d: "M336.4 475.89h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-28",
    d: "M336.4 478.71h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-29",
    d: "M336.4 481.54h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-30",
    d: "M336.4 484.36h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-31",
    d: "M336.4 487.18h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-32",
    d: "M336.4 490.01h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-33",
    d: "M336.4 492.83h28.23",
    className: "boat-layout_svg__cls-1"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-34",
    d: "M336.61 495.66h28.02",
    className: "boat-layout_svg__cls-1"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-35",
    d: "M285.57 512.6h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-36",
    d: "M285.57 509.78h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-37",
    d: "M285.57 506.95h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-38",
    d: "M285.57 504.13h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-39",
    d: "M285.57 501.3h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-40",
    d: "M268.62 498.48h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-41",
    d: "M268.62 495.66h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-42",
    d: "M268.62 492.83h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-43",
    d: "M268.62 490.01h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-44",
    d: "M268.62 487.18h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-45",
    d: "M268.62 484.36h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-46",
    d: "M268.62 481.54h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-47",
    d: "M268.62 478.71h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-48",
    d: "M268.62 475.89h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-49",
    d: "M268.62 473.06h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-50",
    d: "M268.62 470.24h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-51",
    d: "M268.62 467.42h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-52",
    d: "M268.62 464.59h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-53",
    d: "M268.62 461.77h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-54",
    d: "M268.62 458.95h11.5",
    className: "boat-layout_svg__cls-1"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-55",
    d: "M285.57 515.42h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-56",
    d: "M285.57 518.25h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-57",
    d: "M285.57 521.07h5.64",
    className: "boat-layout_svg__cls-1"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-58",
    d: "M268.62 523.89h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-59",
    d: "M268.62 526.72h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-60",
    d: "M336.4 526.72h31.06",
    className: "boat-layout_svg__cls-1"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-61",
    d: "M268.62 529.54h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-62",
    d: "M336.4 529.54h30.84",
    className: "boat-layout_svg__cls-1"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-63",
    d: "M268.62 532.37h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-64",
    d: "M346.24 532.37h18.39",
    className: "boat-layout_svg__cls-1"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-65",
    d: "M336.4 532.37h9.84",
    className: "boat-layout_svg__cls-1"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-66",
    d: "M268.62 535.19h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-67",
    d: "M344.93 535.19h19.7",
    className: "boat-layout_svg__cls-1"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-68",
    d: "M336.4 535.19h8.53",
    className: "boat-layout_svg__cls-1"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-69",
    d: "M268.62 538.01h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-70",
    d: "M344.87 538.01h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-71",
    d: "M336.4 538.01h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-72",
    d: "M268.62 540.84h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-73",
    d: "M344.87 540.84h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-74",
    d: "M336.4 540.84h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-75",
    d: "M268.62 543.66h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-76",
    d: "M344.87 543.66h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-77",
    d: "M336.4 543.66h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-78",
    d: "M268.62 546.49h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-79",
    d: "M344.87 546.49h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-80",
    d: "M336.4 546.49h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-81",
    d: "M268.62 549.31h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-82",
    d: "M344.87 549.31h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-83",
    d: "M336.4 549.31h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-84",
    d: "M268.62 552.13h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-85",
    d: "M344.87 552.13h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-86",
    d: "M336.4 552.13h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-87",
    d: "M268.62 554.96h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-88",
    d: "M344.87 554.96h19.76",
    className: "boat-layout_svg__cls-1"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-89",
    d: "M336.4 554.96h8.47",
    className: "boat-layout_svg__cls-1"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-90",
    d: "M268.62 557.78h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-91",
    d: "M345.22 557.78h19.41",
    className: "boat-layout_svg__cls-1"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-92",
    d: "M336.4 557.78h8.82",
    className: "boat-layout_svg__cls-1"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-93",
    d: "M268.62 560.61h22.54",
    className: "boat-layout_svg__cls-1"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-94",
    d: "M347.51 560.61h17.12",
    className: "boat-layout_svg__cls-1"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-95",
    d: "M345.94 560.61h1.57",
    className: "boat-layout_svg__cls-1"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-96",
    d: "M268.62 563.43h2.35",
    className: "boat-layout_svg__cls-1"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-97",
    d: "M336.61 566.25h25.87",
    className: "boat-layout_svg__cls-1"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-98",
    d: "M.35 579.1V442.19",
    className: "boat-layout_svg__cls-1"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-99",
    d: "M248.86 416.04 10.95 430.91",
    className: "boat-layout_svg__cls-1"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-100",
    d: "M248.86 605.24 10.95 590.37",
    className: "boat-layout_svg__cls-1"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC",
    d: "M10.95 430.91C5 431.28.36 436.22.36 442.18",
    className: "boat-layout_svg__cls-1"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-2",
    d: "M.35 579.1c0 5.96 4.64 10.9 10.59 11.27",
    className: "boat-layout_svg__cls-1"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-3",
    d: "M615.96 592.54a479.7 479.7 0 0 0 240.76-80.48",
    className: "boat-layout_svg__cls-1"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-4",
    d: "M856.72 509.23a479.7 479.7 0 0 0-240.76-80.48",
    className: "boat-layout_svg__cls-1"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-5",
    d: "M333.57 605.24c94.28.46 188.53-3.78 282.39-12.71",
    className: "boat-layout_svg__cls-1"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-6",
    d: "M615.96 428.75a2836 2836 0 0 0-282.39-12.71",
    className: "boat-layout_svg__cls-1"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-101",
    d: "M22.95 579.1V442.19",
    className: "boat-layout_svg__cls-1"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-7",
    d: "M33.34 429.51a14.51 14.51 0 0 0-10.4 12.67",
    className: "boat-layout_svg__cls-1"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-8",
    d: "M22.95 579.1c.51 5.97 4.65 11 10.4 12.67",
    className: "boat-layout_svg__cls-1"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-102",
    d: "M56.83 576.97v-46.56",
    className: "boat-layout_svg__cls-1"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-103",
    d: "M249.21 599.61 67.42 588.24",
    className: "boat-layout_svg__cls-1"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-104",
    d: "M249.21 421.68 67.42 433.04",
    className: "boat-layout_svg__cls-1"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-9",
    d: "M67.42 433.04c-5.95.37-10.59 5.31-10.59 11.27",
    className: "boat-layout_svg__cls-1"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-10",
    d: "M56.83 576.97c0 5.96 4.64 10.9 10.59 11.27",
    className: "boat-layout_svg__cls-1"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-11",
    d: "M700.68 441.05a2327.7 2327.7 0 0 0-451.82-19.35",
    className: "boat-layout_svg__cls-1"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-12",
    d: "M249.21 599.61c150.76 8.2 301.96 1.72 451.47-19.37",
    className: "boat-layout_svg__cls-1"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-105",
    d: "M113.31 569.94v-118.6",
    className: "boat-layout_svg__cls-1"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-106",
    d: "M22.95 445.69h33.88",
    className: "boat-layout_svg__cls-1"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-107",
    d: "M22.95 575.59h33.88",
    className: "boat-layout_svg__cls-1"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-13",
    d: "M113.31 451.34a5.65 5.65 0 0 0-5.65-5.65",
    className: "boat-layout_svg__cls-1"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-14",
    d: "M107.66 575.59a5.65 5.65 0 0 0 5.65-5.65",
    className: "boat-layout_svg__cls-1"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-108",
    d: "M45.54 490.88h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-109",
    d: "M45.54 530.41h22.59",
    className: "boat-layout_svg__cls-1"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-110",
    d: "M68.13 530.41v-39.53",
    className: "boat-layout_svg__cls-1"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-111",
    d: "M45.54 530.41v-39.53",
    className: "boat-layout_svg__cls-1"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-112",
    d: "M56.83 490.88v-46.57",
    className: "boat-layout_svg__cls-1"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-15",
    d: "M436.42 577.29c36.06-37.11 36.06-96.17 0-133.29",
    className: "boat-layout_svg__cls-1"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-113",
    d: "m434.92 578.09-67.46 10.21",
    className: "boat-layout_svg__cls-1"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-16",
    d: "M192.38 584.74c58.23 4.86 116.7 6.05 175.08 3.56",
    className: "boat-layout_svg__cls-1"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-114",
    d: "m435.07 443.22-67.61-10.23",
    className: "boat-layout_svg__cls-1"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-17",
    d: "M367.46 432.99c-58.38-2.49-116.85-1.3-175.08 3.56",
    className: "boat-layout_svg__cls-1"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-18",
    d: "M377.27 565.89c24.58-32.73 24.58-77.76 0-110.49",
    className: "boat-layout_svg__cls-1"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-19",
    d: "M386.19 568.01c23.98-34.48 23.98-80.24 0-114.73",
    className: "boat-layout_svg__cls-1"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-20",
    d: "M377.27 455.4c-.11-.15-.23-.3-.35-.45",
    className: "boat-layout_svg__cls-1"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-21",
    d: "M433.63 578.04a404.64 404.64 0 0 0-241.25 6.7",
    className: "boat-layout_svg__cls-1"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-22",
    d: "M414.87 574.98a276.03 276.03 0 0 0-159.11 4.95",
    className: "boat-layout_svg__cls-1"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-23",
    d: "M376.67 566.65c.2-.25.4-.5.6-.76",
    className: "boat-layout_svg__cls-1"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-24",
    d: "M256 582.12a562.9 562.9 0 0 0 158.77-4.93",
    className: "boat-layout_svg__cls-1"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-25",
    d: "M414.77 577.18c.61-.11 1.03-.69.92-1.31-.08-.43-.4-.78-.82-.9",
    className: "boat-layout_svg__cls-1"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-26",
    d: "M255.76 579.92c-.59.2-.91.84-.71 1.43.14.42.51.72.95.76",
    className: "boat-layout_svg__cls-1"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-27",
    d: "M192.38 436.55a404.64 404.64 0 0 0 241.25 6.7",
    className: "boat-layout_svg__cls-1"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-28",
    d: "M255.76 441.36a276.2 276.2 0 0 0 159.11 4.95",
    className: "boat-layout_svg__cls-1"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-29",
    d: "M414.77 444.1A562.9 562.9 0 0 0 256 439.17",
    className: "boat-layout_svg__cls-1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-30",
    d: "M414.87 446.31c.6-.16.96-.78.8-1.38-.11-.42-.46-.75-.9-.82",
    className: "boat-layout_svg__cls-1"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-31",
    d: "M256 439.17a1.133 1.133 0 0 0-.24 2.2",
    className: "boat-layout_svg__cls-1"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-115",
    d: "M192.38 436.55v2.83",
    className: "boat-layout_svg__cls-1"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-116",
    d: "M192.38 584.74v-2.83",
    className: "boat-layout_svg__cls-1"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-117",
    d: "M322.28 458.46v104.37",
    className: "boat-layout_svg__cls-1"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-118",
    d: "M294.04 457.37v106.54",
    className: "boat-layout_svg__cls-1"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#boat-layout_svg__ARC-32",
    className: "boat-layout_svg__cls-1"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-119",
    d: "M121.78 567.06V454.23",
    className: "boat-layout_svg__cls-1"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-33",
    d: "M135.02 440.13c-7.44.47-13.24 6.64-13.24 14.09",
    className: "boat-layout_svg__cls-1"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-120",
    d: "m192.2 436.56-57.18 3.57",
    className: "boat-layout_svg__cls-1"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-121",
    d: "m192.2 584.73-57.18-3.58",
    className: "boat-layout_svg__cls-1"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-34",
    d: "M121.78 567.06c0 7.46 5.8 13.63 13.24 14.09",
    className: "boat-layout_svg__cls-1"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-122",
    d: "M248.86 416.04h84.71",
    className: "boat-layout_svg__cls-1"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-123",
    d: "M248.86 605.24h84.71",
    className: "boat-layout_svg__cls-1"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-35",
    d: "M436.42 444a2.83 2.83 0 0 0-2.79-.75",
    className: "boat-layout_svg__cls-1"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-36",
    d: "M433.63 578.04c1 .28 2.07 0 2.79-.75",
    className: "boat-layout_svg__cls-1"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-124",
    d: "M59.66 445.69h48",
    className: "boat-layout_svg__cls-1"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-125",
    d: "M59.66 575.59h48",
    className: "boat-layout_svg__cls-1"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-126",
    d: "M59.66 576.97v-46.56",
    className: "boat-layout_svg__cls-1"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-37",
    d: "M59.66 576.97c0 4.47 3.48 8.18 7.94 8.46",
    className: "boat-layout_svg__cls-1"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-38",
    d: "M67.6 435.86a8.473 8.473 0 0 0-7.94 8.46",
    className: "boat-layout_svg__cls-1"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-127",
    d: "M249.02 424.52 67.6 435.86",
    className: "boat-layout_svg__cls-1"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-128",
    d: "M249.37 596.79 67.6 585.43",
    className: "boat-layout_svg__cls-1"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-39",
    d: "M249.37 596.79a2668 2668 0 0 0 451.3-16.55",
    className: "boat-layout_svg__cls-1"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-40",
    d: "M700.68 441.05a2667 2667 0 0 0-451.66-16.53",
    className: "boat-layout_svg__cls-1"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-129",
    d: "M59.66 490.88v-46.57",
    className: "boat-layout_svg__cls-1"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-130",
    d: "M110.49 569.94v-118.6",
    className: "boat-layout_svg__cls-1"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-41",
    d: "M110.49 451.34a5.65 5.65 0 0 0-5.65-5.65",
    className: "boat-layout_svg__cls-1"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-42",
    d: "M104.84 575.59a5.65 5.65 0 0 0 5.65-5.65",
    className: "boat-layout_svg__cls-1"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-131",
    d: "m88.71 437.37-14.65.92",
    className: "boat-layout_svg__cls-1"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-132",
    d: "m88.89 440.19-14.66.91",
    className: "boat-layout_svg__cls-1"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-133",
    d: "m89.95 438.99-.04-.56",
    className: "boat-layout_svg__cls-1"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-134",
    d: "m73.04 440.05-.04-.57",
    className: "boat-layout_svg__cls-1"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-43",
    d: "M89.91 438.43c-.04-.62-.58-1.1-1.2-1.06",
    className: "boat-layout_svg__cls-1"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-44",
    d: "M88.89 440.19c.62-.04 1.1-.58 1.06-1.2",
    className: "boat-layout_svg__cls-1"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-45",
    d: "M74.06 438.29c-.62.04-1.1.58-1.06 1.2",
    className: "boat-layout_svg__cls-1"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-46",
    d: "M73.04 440.05c.04.62.58 1.1 1.2 1.06",
    className: "boat-layout_svg__cls-1"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-135",
    d: "m88.89 581.1-14.66-.92",
    className: "boat-layout_svg__cls-1"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-136",
    d: "M88.71 583.92 74.06 583",
    className: "boat-layout_svg__cls-1"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-47",
    d: "M74.23 580.18a1.13 1.13 0 0 0-1.2 1.06",
    className: "boat-layout_svg__cls-1"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-137",
    d: "m73.04 581.24-.04.56",
    className: "boat-layout_svg__cls-1"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-48",
    d: "M73 581.8c-.04.62.43 1.16 1.06 1.2",
    className: "boat-layout_svg__cls-1"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-49",
    d: "M89.95 582.3a1.13 1.13 0 0 0-1.06-1.2",
    className: "boat-layout_svg__cls-1"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-138",
    d: "m89.95 582.3-.04.56",
    className: "boat-layout_svg__cls-1"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-50",
    d: "M88.71 583.92c.62.04 1.16-.43 1.2-1.06",
    className: "boat-layout_svg__cls-1"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-139",
    d: "M124.6 567.06V454.23",
    className: "boat-layout_svg__cls-1"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-140",
    d: "m192.38 439.38-57.18 3.57",
    className: "boat-layout_svg__cls-1"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-141",
    d: "m192.38 581.91-57.18-3.58",
    className: "boat-layout_svg__cls-1"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-51",
    d: "M135.2 442.95c-5.95.37-10.59 5.31-10.59 11.27",
    className: "boat-layout_svg__cls-1"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-52",
    d: "M124.6 567.06c0 5.96 4.64 10.9 10.59 11.27",
    className: "boat-layout_svg__cls-1"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-53",
    d: "M257.29 579.42a560 560 0 0 0 156.03-4.85",
    className: "boat-layout_svg__cls-1"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-54",
    d: "M413.32 446.72a560.4 560.4 0 0 0-156.03-4.85",
    className: "boat-layout_svg__cls-1"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-55",
    d: "M290.18 561.38a408 408 0 0 0-98.72 20.68",
    className: "boat-layout_svg__cls-1"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-142",
    d: "M291.21 461.03v99.23",
    className: "boat-layout_svg__cls-1"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-56",
    d: "M191.46 439.22a407.3 407.3 0 0 0 98.72 20.68",
    className: "boat-layout_svg__cls-1"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-57",
    d: "M290.18 561.38c.59-.05 1.04-.54 1.04-1.13",
    className: "boat-layout_svg__cls-1"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-58",
    d: "M291.21 461.03c0-.59-.45-1.08-1.04-1.13",
    className: "boat-layout_svg__cls-1"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-143",
    d: "M325.1 462.97v95.35",
    className: "boat-layout_svg__cls-1"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-59",
    d: "M326.78 461.27c16.12-.12 32.22-1.2 48.21-3.23",
    className: "boat-layout_svg__cls-1"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-60",
    d: "M376.05 562.78c22.43-31.14 22.43-73.13 0-104.27",
    className: "boat-layout_svg__cls-1"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-61",
    d: "M374.99 563.24a407 407 0 0 0-48.21-3.23",
    className: "boat-layout_svg__cls-1"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-62",
    d: "M374.99 563.24c.41.05.82-.12 1.06-.46",
    className: "boat-layout_svg__cls-1"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-63",
    d: "M376.05 458.51c-.24-.34-.65-.51-1.06-.46",
    className: "boat-layout_svg__cls-1"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-64",
    d: "M326.22 461.28c-.62 0-1.12.51-1.12 1.13",
    className: "boat-layout_svg__cls-1"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-65",
    d: "M326.78 461.27c-.93 0-1.68.76-1.68 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-66",
    d: "M325.1 558.32c0 .93.75 1.69 1.68 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-144",
    d: "M336.4 438.86v16.73",
    className: "boat-layout_svg__cls-1"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-145",
    d: "M338.09 496.52h53.66",
    className: "boat-layout_svg__cls-1"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-67",
    d: "M336.4 494.83c0 .94.76 1.69 1.69 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-146",
    d: "M336.4 461.09v33.74",
    className: "boat-layout_svg__cls-1"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-147",
    d: "M344.87 461.09v35.43",
    className: "boat-layout_svg__cls-1"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-148",
    d: "M344.87 439.2v16.39",
    className: "boat-layout_svg__cls-1"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-149",
    d: "M364.63 440.5v14.38",
    className: "boat-layout_svg__cls-1"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-150",
    d: "M364.63 459.23v37.29",
    className: "boat-layout_svg__cls-1"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-151",
    d: "M375.93 441.56v12.22",
    className: "boat-layout_svg__cls-1"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-152",
    d: "M375.93 458.37v38.15",
    className: "boat-layout_svg__cls-1"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-153",
    d: "M338.09 524.76h27.67",
    className: "boat-layout_svg__cls-1"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-154",
    d: "M336.4 526.46v33.74",
    className: "boat-layout_svg__cls-1"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-68",
    d: "M338.09 524.76c-.94 0-1.69.76-1.69 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-155",
    d: "M364.63 530.41v31.06",
    className: "boat-layout_svg__cls-1"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-156",
    d: "M350.52 530.41h15.24",
    className: "boat-layout_svg__cls-1"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#boat-layout_svg__LINE-157",
    className: "boat-layout_svg__cls-1"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-69",
    d: "M367.46 526.46c0-.94-.76-1.69-1.69-1.69",
    className: "boat-layout_svg__cls-1"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-70",
    d: "M365.76 530.41c.94 0 1.69-.76 1.69-1.69",
    className: "boat-layout_svg__cls-1"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-158",
    d: "M338.09 567.12h27.67",
    className: "boat-layout_svg__cls-1"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-71",
    d: "M336.42 565.69c.13.82.84 1.43 1.67 1.43",
    className: "boat-layout_svg__cls-1"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#boat-layout_svg__LINE-157",
    id: "boat-layout_svg__LINE-159",
    className: "boat-layout_svg__cls-1"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-160",
    d: "M344.87 536.06v19.76",
    className: "boat-layout_svg__cls-1"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-72",
    d: "M350.52 530.41a5.65 5.65 0 0 0-5.65 5.65",
    className: "boat-layout_svg__cls-1"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-161",
    d: "M358.35 561.47h7.41",
    className: "boat-layout_svg__cls-1"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-73",
    d: "M344.87 555.82c0 2.01 1.07 3.87 2.8 4.88",
    className: "boat-layout_svg__cls-1"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-74",
    d: "M367.24 562.33c-.3-.53-.86-.86-1.47-.86",
    className: "boat-layout_svg__cls-1"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#boat-layout_svg__ARC-32",
    id: "boat-layout_svg__ARC-75",
    className: "boat-layout_svg__cls-1"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-162",
    d: "M387.23 496.52v24.66",
    className: "boat-layout_svg__cls-1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-163",
    d: "M385.9 521.18h6.35",
    className: "boat-layout_svg__cls-1"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-164",
    d: "M384.21 522.87v26.12",
    className: "boat-layout_svg__cls-1"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-76",
    d: "M385.9 521.18c-.94 0-1.69.76-1.69 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-165",
    d: "M381.38 536.72v17.71",
    className: "boat-layout_svg__cls-1"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-166",
    d: "M381.38 536.72h2.83",
    className: "boat-layout_svg__cls-1"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-167",
    d: "M268.62 457.54v106.2",
    className: "boat-layout_svg__cls-1"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-168",
    d: "M285.57 499.35v22.59",
    className: "boat-layout_svg__cls-1"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-169",
    d: "M268.62 521.94h16.95",
    className: "boat-layout_svg__cls-1"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-170",
    d: "M268.62 499.35h16.95",
    className: "boat-layout_svg__cls-1"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-171",
    d: "M260.15 456.3v108.69",
    className: "boat-layout_svg__cls-1"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-172",
    d: "M706.32 563.68v.57",
    className: "boat-layout_svg__cls-1"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-173",
    d: "M480.41 583.65v.56",
    className: "boat-layout_svg__cls-1"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-77",
    d: "M481.58 585.34c74.92-2.3 149.64-8.97 223.78-19.98",
    className: "boat-layout_svg__cls-1"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-78",
    d: "M481.51 582.52c74.83-2.3 149.46-8.97 223.52-19.96",
    className: "boat-layout_svg__cls-1"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-79",
    d: "M705.03 458.72a1926 1926 0 0 0-223.52-19.96",
    className: "boat-layout_svg__cls-1"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-80",
    d: "M705.36 455.92c-74.14-11-148.86-17.67-223.78-19.98",
    className: "boat-layout_svg__cls-1"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-174",
    d: "M706.32 457.61v-.57",
    className: "boat-layout_svg__cls-1"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-175",
    d: "M480.41 437.64v-.57",
    className: "boat-layout_svg__cls-1"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-81",
    d: "M750.87 547.44c12.23-3.76 24.32-7.95 36.26-12.56",
    className: "boat-layout_svg__cls-1"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-176",
    d: "M748.68 475.47v26.42",
    className: "boat-layout_svg__cls-1"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-177",
    d: "M750.38 503.58h36.14",
    className: "boat-layout_svg__cls-1"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-178",
    d: "M750.38 517.7h36.14",
    className: "boat-layout_svg__cls-1"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-179",
    d: "M748.68 519.4v26.42",
    className: "boat-layout_svg__cls-1"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-180",
    d: "M788.22 519.4v13.89",
    className: "boat-layout_svg__cls-1"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-82",
    d: "M793.37 532.42c8.4-3.37 16.71-6.94 24.93-10.73",
    className: "boat-layout_svg__cls-1"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-83",
    d: "M787.13 486.41c-11.93-4.61-24.03-8.8-36.26-12.56",
    className: "boat-layout_svg__cls-1"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-181",
    d: "M788.22 487.99v13.9",
    className: "boat-layout_svg__cls-1"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-84",
    d: "M818.29 499.59a549 549 0 0 0-24.93-10.73",
    className: "boat-layout_svg__cls-1"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-182",
    d: "M791.04 490.44v40.41",
    className: "boat-layout_svg__cls-1"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-183",
    d: "M819.28 501.13v19.02",
    className: "boat-layout_svg__cls-1"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-85",
    d: "M750.87 473.85c-.89-.27-1.84.23-2.12 1.12-.05.16-.07.33-.07.5",
    className: "boat-layout_svg__cls-1"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-86",
    d: "M748.68 501.89c0 .94.76 1.69 1.69 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-87",
    d: "M786.52 503.58c.94 0 1.69-.76 1.69-1.69",
    className: "boat-layout_svg__cls-1"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-88",
    d: "M788.22 487.99c0-.7-.43-1.33-1.08-1.58",
    className: "boat-layout_svg__cls-1"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-89",
    d: "M750.38 517.7c-.94 0-1.69.76-1.69 1.69",
    className: "boat-layout_svg__cls-1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-90",
    d: "M748.68 545.82c0 .94.76 1.69 1.69 1.69.17 0 .34-.03.5-.07",
    className: "boat-layout_svg__cls-1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-91",
    d: "M788.22 519.4c0-.94-.76-1.69-1.69-1.69",
    className: "boat-layout_svg__cls-1"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-92",
    d: "M787.13 534.87c.65-.25 1.08-.88 1.08-1.58",
    className: "boat-layout_svg__cls-1"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-93",
    d: "M791.04 530.85c0 .94.76 1.69 1.69 1.69q.33 0 .63-.12",
    className: "boat-layout_svg__cls-1"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-94",
    d: "M793.37 488.87a1.687 1.687 0 0 0-2.32 1.57",
    className: "boat-layout_svg__cls-1"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-95",
    d: "M819.28 501.13c0-.66-.38-1.26-.99-1.54",
    className: "boat-layout_svg__cls-1"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-96",
    d: "M818.29 521.69c.6-.28.99-.88.99-1.54",
    className: "boat-layout_svg__cls-1"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-184",
    d: "m817.96 495.09.24-.51",
    className: "boat-layout_svg__cls-1"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-185",
    d: "m803.89 488.92.22-.52",
    className: "boat-layout_svg__cls-1"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-186",
    d: "m817.96 526.19.24.51",
    className: "boat-layout_svg__cls-1"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-187",
    d: "m803.89 532.36.22.52",
    className: "boat-layout_svg__cls-1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "boat-layout_svg__CIRCLE",
    cx: 805.49,
    cy: 498.39,
    r: 1.41,
    className: "boat-layout_svg__cls-1"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "boat-layout_svg__CIRCLE-2",
    cx: 769.49,
    cy: 483.38,
    r: 1.41,
    className: "boat-layout_svg__cls-1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "boat-layout_svg__CIRCLE-3",
    cx: 769.49,
    cy: 537.9,
    r: 1.41,
    className: "boat-layout_svg__cls-1"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-188",
    d: "M848.65 512.05h20.33",
    className: "boat-layout_svg__cls-1"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-189",
    d: "M848.65 509.23h20.33",
    className: "boat-layout_svg__cls-1"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-190",
    d: "M847.52 510.36v.57",
    className: "boat-layout_svg__cls-1"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-191",
    d: "M870.11 510.36v.57",
    className: "boat-layout_svg__cls-1"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-97",
    d: "M848.65 509.23c-.62 0-1.13.51-1.13 1.13",
    className: "boat-layout_svg__cls-1"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-98",
    d: "M870.11 510.36c0-.62-.51-1.13-1.13-1.13",
    className: "boat-layout_svg__cls-1"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-99",
    d: "M847.52 510.93c0 .62.51 1.13 1.13 1.13",
    className: "boat-layout_svg__cls-1"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-100",
    d: "M868.98 512.05c.62 0 1.13-.51 1.13-1.13",
    className: "boat-layout_svg__cls-1"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-101",
    d: "M866.74 509.23c-5-3.48-10.07-6.86-15.2-10.15",
    className: "boat-layout_svg__cls-1"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-102",
    d: "M851.54 499.08a5.643 5.643 0 0 0-7.8 1.71s-.01.02-.02.03",
    className: "boat-layout_svg__cls-1"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-103",
    d: "M851.54 499.08c3.47 3.92 7.48 7.34 11.91 10.15",
    className: "boat-layout_svg__cls-1"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-104",
    d: "M851.54 522.2c5.13-3.29 10.2-6.67 15.2-10.15",
    className: "boat-layout_svg__cls-1"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-105",
    d: "M863.45 512.05a55.6 55.6 0 0 0-11.91 10.15",
    className: "boat-layout_svg__cls-1"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-106",
    d: "M843.72 520.47a5.64 5.64 0 0 0 7.79 1.75s.02-.01.03-.02",
    className: "boat-layout_svg__cls-1"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-107",
    d: "M481.58 435.94c-.62-.02-1.14.47-1.16 1.09v.03",
    className: "boat-layout_svg__cls-1"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-108",
    d: "M480.41 437.64c0 .61.48 1.11 1.09 1.13",
    className: "boat-layout_svg__cls-1"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-109",
    d: "M706.32 457.04c0-.56-.41-1.04-.96-1.12",
    className: "boat-layout_svg__cls-1"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-110",
    d: "M705.03 458.72c.62.09 1.19-.33 1.28-.95 0-.05.01-.11.01-.17",
    className: "boat-layout_svg__cls-1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-111",
    d: "M481.51 582.52c-.61.02-1.09.52-1.09 1.13",
    className: "boat-layout_svg__cls-1"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-112",
    d: "M480.41 584.21c0 .62.51 1.13 1.13 1.13h.03",
    className: "boat-layout_svg__cls-1"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-113",
    d: "M706.32 563.68c0-.62-.51-1.13-1.13-1.13-.06 0-.11 0-.17.01",
    className: "boat-layout_svg__cls-1"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-114",
    d: "M705.36 565.37c.55-.08.96-.56.96-1.12",
    className: "boat-layout_svg__cls-1"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-115",
    d: "M803.89 488.92c-.24.57.03 1.24.6 1.48",
    className: "boat-layout_svg__cls-1"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-116",
    d: "M805.59 487.8c-.57-.24-1.24.02-1.48.6q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-117",
    d: "M818.2 494.58c.26-.57 0-1.24-.56-1.5q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-118",
    d: "M816.47 495.66c.57.26 1.24 0 1.49-.56",
    className: "boat-layout_svg__cls-1"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-119",
    d: "M817.96 526.19c-.26-.57-.93-.82-1.49-.56",
    className: "boat-layout_svg__cls-1"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-120",
    d: "M817.63 528.2c.57-.26.82-.93.56-1.5q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-121",
    d: "M804.11 532.88c.24.57.91.84 1.48.6q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-122",
    d: "M804.49 530.89c-.57.24-.84.9-.6 1.48",
    className: "boat-layout_svg__cls-1"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-123",
    d: "M594.14 588.24c1.5-.12 3-.25 4.5-.37",
    className: "boat-layout_svg__cls-1"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-124",
    d: "M593.9 585.42c1.5-.12 3-.25 4.5-.37",
    className: "boat-layout_svg__cls-1"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-192",
    d: "m599.63 586.08.04.57",
    className: "boat-layout_svg__cls-1"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-193",
    d: "m592.87 586.64.05.57",
    className: "boat-layout_svg__cls-1"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-125",
    d: "M599.63 586.08c-.05-.62-.6-1.08-1.22-1.03",
    className: "boat-layout_svg__cls-1"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-126",
    d: "M598.64 587.87c.62-.05 1.08-.6 1.03-1.22q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-127",
    d: "M593.9 585.42c-.62.05-1.08.6-1.03 1.22q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-128",
    d: "M592.92 587.21c.05.62.6 1.08 1.22 1.03",
    className: "boat-layout_svg__cls-1"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-129",
    d: "m514.77 593.52 4.51-.24",
    className: "boat-layout_svg__cls-1"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-130",
    d: "m514.62 590.7 4.51-.24",
    className: "boat-layout_svg__cls-1"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-194",
    d: "m513.55 591.88.03.57",
    className: "boat-layout_svg__cls-1"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-195",
    d: "m520.32 591.53.03.56",
    className: "boat-layout_svg__cls-1"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-131",
    d: "M514.62 590.7c-.62.03-1.1.56-1.07 1.19",
    className: "boat-layout_svg__cls-1"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-132",
    d: "M520.32 591.53c-.03-.62-.56-1.1-1.19-1.07q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-133",
    d: "M513.58 592.45c.03.62.56 1.1 1.19 1.07q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-134",
    d: "M519.28 593.28c.62-.03 1.1-.56 1.07-1.19",
    className: "boat-layout_svg__cls-1"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-135",
    d: "M393.62 597c1.51 0 3.01-.02 4.52-.03",
    className: "boat-layout_svg__cls-1"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-136",
    d: "M393.6 594.18c1.51 0 3.01-.02 4.52-.03",
    className: "boat-layout_svg__cls-1"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-196",
    d: "M392.48 595.31v.57",
    className: "boat-layout_svg__cls-1"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-197",
    d: "M399.26 595.27v.56",
    className: "boat-layout_svg__cls-1"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-137",
    d: "M399.26 595.27c0-.62-.51-1.13-1.14-1.12q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-138",
    d: "M398.14 596.97c.62 0 1.12-.51 1.12-1.14",
    className: "boat-layout_svg__cls-1"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-139",
    d: "M392.48 595.88c0 .62.51 1.13 1.14 1.12q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-140",
    d: "M393.6 594.18c-.62 0-1.13.51-1.12 1.14",
    className: "boat-layout_svg__cls-1"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-141",
    d: "M256.57 594.3c1.51.07 3.01.14 4.52.2",
    className: "boat-layout_svg__cls-1"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-142",
    d: "M256.7 591.48c1.5.07 3.01.14 4.51.2",
    className: "boat-layout_svg__cls-1"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-198",
    d: "m255.52 592.55-.03.57",
    className: "boat-layout_svg__cls-1"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-199",
    d: "m262.29 592.86-.03.56",
    className: "boat-layout_svg__cls-1"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-143",
    d: "M256.7 591.48a1.13 1.13 0 0 0-1.18 1.08",
    className: "boat-layout_svg__cls-1"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-144",
    d: "M255.49 593.12c-.03.62.45 1.15 1.08 1.18q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-145",
    d: "M262.29 592.86a1.13 1.13 0 0 0-1.08-1.18s0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-146",
    d: "M261.09 594.5c.62.03 1.15-.45 1.18-1.08",
    className: "boat-layout_svg__cls-1"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-147",
    d: "M261.21 429.61a1.13 1.13 0 0 0 1.08-1.18s0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-148",
    d: "M261.21 429.61c-1.5.07-3.01.13-4.51.2",
    className: "boat-layout_svg__cls-1"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-149",
    d: "M255.52 428.73c.03.62.56 1.1 1.18 1.08",
    className: "boat-layout_svg__cls-1"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-150",
    d: "M261.09 426.79c-1.51.07-3.01.13-4.52.2",
    className: "boat-layout_svg__cls-1"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-151",
    d: "M256.57 426.99c-.62.03-1.11.56-1.08 1.18q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-200",
    d: "m255.52 428.73-.03-.56",
    className: "boat-layout_svg__cls-1"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-152",
    d: "M262.26 427.86c-.03-.62-.56-1.1-1.18-1.08",
    className: "boat-layout_svg__cls-1"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-201",
    d: "m262.29 428.43-.03-.57",
    className: "boat-layout_svg__cls-1"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-153",
    d: "M392.48 425.97c0 .62.5 1.13 1.12 1.14",
    className: "boat-layout_svg__cls-1"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-154",
    d: "m398.12 427.14-4.52-.03",
    className: "boat-layout_svg__cls-1"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-202",
    d: "M392.48 425.97v-.56",
    className: "boat-layout_svg__cls-1"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-155",
    d: "M393.62 424.29c-.62 0-1.13.5-1.14 1.12q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-156",
    d: "m398.14 424.32-4.52-.03",
    className: "boat-layout_svg__cls-1"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-157",
    d: "M399.26 425.45c0-.62-.5-1.13-1.12-1.14",
    className: "boat-layout_svg__cls-1"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-203",
    d: "M399.26 426.02v-.57",
    className: "boat-layout_svg__cls-1"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-158",
    d: "M398.12 427.14c.62 0 1.13-.5 1.14-1.12q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-204",
    d: "m520.32 429.75.03-.56",
    className: "boat-layout_svg__cls-1"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-159",
    d: "M513.55 429.4c-.03.62.45 1.15 1.07 1.19",
    className: "boat-layout_svg__cls-1"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-160",
    d: "m519.28 428.01-4.51-.24",
    className: "boat-layout_svg__cls-1"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-161",
    d: "M514.77 427.77c-.62-.03-1.15.45-1.19 1.07q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-205",
    d: "m513.55 429.4.03-.56",
    className: "boat-layout_svg__cls-1"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-162",
    d: "M520.35 429.19c.03-.62-.45-1.15-1.07-1.19",
    className: "boat-layout_svg__cls-1"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-163",
    d: "m519.13 430.83-4.51-.24",
    className: "boat-layout_svg__cls-1"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-164",
    d: "M519.13 430.83c.62.03 1.15-.44 1.19-1.07q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-165",
    d: "M598.64 433.42c-1.5-.12-3-.25-4.5-.37",
    className: "boat-layout_svg__cls-1"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-166",
    d: "M598.41 436.23c-1.5-.12-3-.25-4.5-.37",
    className: "boat-layout_svg__cls-1"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-167",
    d: "M594.14 433.05c-.62-.05-1.17.41-1.22 1.03",
    className: "boat-layout_svg__cls-1"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-206",
    d: "m592.87 434.64.05-.56",
    className: "boat-layout_svg__cls-1"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-168",
    d: "M592.87 434.64c-.05.62.41 1.17 1.03 1.22q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-169",
    d: "M599.67 434.64c.05-.62-.41-1.17-1.03-1.22q0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-207",
    d: "m599.63 435.2.04-.56",
    className: "boat-layout_svg__cls-1"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-170",
    d: "M598.41 436.23c.62.05 1.17-.41 1.22-1.03",
    className: "boat-layout_svg__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "boat-layout_svg__Group_417"
  }, /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_37",
    d: "M917.16 416.01v189.27",
    className: "boat-layout_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_41",
    d: "M911.37 416.01h11.58",
    className: "boat-layout_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_42",
    d: "M911.37 605.28h11.58",
    className: "boat-layout_svg__cls-3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "boat-layout_svg__Group_418"
  }, /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_36",
    d: "M2.55 324.5H872.3",
    className: "boat-layout_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_39",
    d: "M2.55 318.71v11.57",
    className: "boat-layout_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_40",
    d: "M872.3 318.71v11.57",
    className: "boat-layout_svg__cls-3"
  }))), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-171",
    d: "M367.46 588.3c111.42 3.17 222.91-3.32 333.22-19.39",
    className: "boat-layout_svg__cls-1"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-172",
    d: "M700.68 568.91a550.2 550.2 0 0 0 155.58-56.85",
    className: "boat-layout_svg__cls-1"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-173",
    d: "M856.25 509.23a549.6 549.6 0 0 0-155.58-56.85",
    className: "boat-layout_svg__cls-1"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-174",
    d: "M700.68 452.38a1930.5 1930.5 0 0 0-333.22-19.39",
    className: "boat-layout_svg__cls-1"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "boat-layout_svg__CIRCLE-4",
    cx: 678.09,
    cy: 510.64,
    r: 14.12,
    className: "boat-layout_svg__cls-1"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-175",
    d: "M507.48 578.72c31.31-1.39 62.59-3.54 93.8-6.46",
    className: "boat-layout_svg__cls-1"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-208",
    d: "M618.98 558.96 602 571.97",
    className: "boat-layout_svg__cls-1"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-209",
    d: "m522.3 564.11-15.74 12.08",
    className: "boat-layout_svg__cls-1"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-176",
    d: "M523.09 563.82c31.69-1.68 63.33-4.14 94.89-7.39",
    className: "boat-layout_svg__cls-1"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-177",
    d: "M617.98 464.86c-31.56-3.25-63.2-5.72-94.89-7.39",
    className: "boat-layout_svg__cls-1"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-210",
    d: "M618.98 462.33 602 449.31",
    className: "boat-layout_svg__cls-1"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-178",
    d: "M601.28 449.03c-31.21-2.92-62.48-5.07-93.8-6.46",
    className: "boat-layout_svg__cls-1"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-211",
    d: "m522.3 457.17-15.74-12.07",
    className: "boat-layout_svg__cls-1"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-179",
    d: "M817.63 493.08c-3.99-1.81-8.01-3.57-12.04-5.28",
    className: "boat-layout_svg__cls-1"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-180",
    d: "M816.47 495.66c-3.97-1.8-7.97-3.55-11.98-5.26",
    className: "boat-layout_svg__cls-1"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-181",
    d: "M805.59 533.49c4.04-1.71 8.05-3.47 12.04-5.28",
    className: "boat-layout_svg__cls-1"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-182",
    d: "M804.49 530.89c4.01-1.7 8.01-3.46 11.98-5.26",
    className: "boat-layout_svg__cls-1"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-183",
    d: "M618.98 558.96c.62-.47.74-1.36.26-1.98-.3-.39-.78-.6-1.27-.55",
    className: "boat-layout_svg__cls-1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-184",
    d: "M523.09 563.82c-.28.02-.56.12-.78.29",
    className: "boat-layout_svg__cls-1"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-185",
    d: "M506.56 576.19c-.62.47-.74 1.36-.26 1.98.28.37.72.57 1.18.55",
    className: "boat-layout_svg__cls-1"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-186",
    d: "M601.28 572.26c.26-.02.52-.12.73-.29",
    className: "boat-layout_svg__cls-1"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-187",
    d: "M617.98 464.86c.78.08 1.47-.48 1.55-1.26.05-.49-.16-.97-.55-1.27",
    className: "boat-layout_svg__cls-1"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-188",
    d: "M602 449.31c-.21-.16-.46-.26-.73-.29",
    className: "boat-layout_svg__cls-1"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-189",
    d: "M507.48 442.57a1.41 1.41 0 0 0-1.47 1.35c-.02.46.19.9.55 1.18",
    className: "boat-layout_svg__cls-1"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-190",
    d: "M522.3 457.17c.23.17.5.27.78.29",
    className: "boat-layout_svg__cls-1"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-212",
    d: "m402.24 125.6 16.38-16.39",
    className: "boat-layout_svg__cls-1"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-213",
    d: "m420.85 106.98 16.8-16.8",
    className: "boat-layout_svg__cls-1"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-214",
    d: "m418.62 109.21.89-.89",
    className: "boat-layout_svg__cls-1"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-215",
    d: "m397.5 125.8 17.28-17.28",
    className: "boat-layout_svg__cls-1"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-216",
    d: "m420.13 103.17 14.56-14.56",
    className: "boat-layout_svg__cls-1"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-217",
    d: "m416.12 107.18 4.01-4.01",
    className: "boat-layout_svg__cls-1"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-218",
    d: "m392.76 126 17.28-17.28",
    className: "boat-layout_svg__cls-1"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-219",
    d: "m421.64 97.12 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-220",
    d: "m411.38 107.38 10.26-10.26",
    className: "boat-layout_svg__cls-1"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-221",
    d: "m388.01 126.22 17.3-17.3",
    className: "boat-layout_svg__cls-1"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-222",
    d: "m423.15 91.07 5.62-5.61",
    className: "boat-layout_svg__cls-1"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-223",
    d: "m406.65 107.58 16.5-16.51",
    className: "boat-layout_svg__cls-1"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-224",
    d: "m383.26 126.44 17.32-17.32",
    className: "boat-layout_svg__cls-1"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-225",
    d: "m424.67 85.03 1.14-1.15",
    className: "boat-layout_svg__cls-1"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-226",
    d: "m401.92 107.78 22.75-22.75",
    className: "boat-layout_svg__cls-1"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-227",
    d: "m378.49 126.67 17.35-17.35",
    className: "boat-layout_svg__cls-1"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-228",
    d: "m397.18 107.98 24.18-24.18",
    className: "boat-layout_svg__cls-1"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-229",
    d: "m373.73 126.9 1.76-1.76",
    className: "boat-layout_svg__cls-1"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-230",
    d: "m392.44 108.19 23.96-23.96",
    className: "boat-layout_svg__cls-1"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-231",
    d: "m368.95 127.14 42.48-42.48",
    className: "boat-layout_svg__cls-1"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-232",
    d: "m364.17 127.39 41.04-41.04",
    className: "boat-layout_svg__cls-1"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-233",
    d: "m359.38 127.65 4.81-4.82",
    className: "boat-layout_svg__cls-1"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-234",
    d: "m364.19 122.83 32.56-32.56",
    className: "boat-layout_svg__cls-1"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-235",
    d: "m354.58 127.91 11.13-11.12",
    className: "boat-layout_svg__cls-1"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-236",
    d: "m365.71 116.79 22.59-22.6",
    className: "boat-layout_svg__cls-1"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-237",
    d: "m349.78 128.18 17.44-17.44",
    className: "boat-layout_svg__cls-1"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-238",
    d: "m367.22 110.74 12.62-12.63",
    className: "boat-layout_svg__cls-1"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-239",
    d: "m347.1 126.33 21.63-21.64",
    className: "boat-layout_svg__cls-1"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-240",
    d: "m368.73 104.69 2.66-2.65",
    className: "boat-layout_svg__cls-1"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-241",
    d: "m344.5 124.39 18.43-18.43",
    className: "boat-layout_svg__cls-1"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-242",
    d: "m341.91 122.45 12.57-12.57",
    className: "boat-layout_svg__cls-1"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-243",
    d: "m339.31 120.51 6.71-6.71",
    className: "boat-layout_svg__cls-1"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-244",
    d: "m336.72 118.57.85-.85",
    className: "boat-layout_svg__cls-1"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-245",
    d: "m406.96 125.4 10.15-10.14",
    className: "boat-layout_svg__cls-1"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-246",
    d: "m425.59 106.78 15.01-15.02",
    className: "boat-layout_svg__cls-1"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-247",
    d: "m417.11 115.26 7.14-7.14",
    className: "boat-layout_svg__cls-1"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-248",
    d: "m411.68 125.21 3.91-3.91",
    className: "boat-layout_svg__cls-1"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-249",
    d: "m430.32 106.58 13.24-13.24",
    className: "boat-layout_svg__cls-1"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-250",
    d: "m415.59 121.3 13.39-13.38",
    className: "boat-layout_svg__cls-1"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-251",
    d: "m416.4 125.03 17.31-17.31",
    className: "boat-layout_svg__cls-1"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-252",
    d: "m435.05 106.38 11.47-11.47",
    className: "boat-layout_svg__cls-1"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-253",
    d: "m421.11 124.86 17.34-17.34",
    className: "boat-layout_svg__cls-1"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-254",
    d: "m439.79 106.18 9.69-9.69",
    className: "boat-layout_svg__cls-1"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-255",
    d: "m425.81 124.69 17.37-17.37",
    className: "boat-layout_svg__cls-1"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-256",
    d: "m444.52 105.98 7.92-7.92",
    className: "boat-layout_svg__cls-1"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-257",
    d: "m430.5 124.53 17.42-17.41",
    className: "boat-layout_svg__cls-1"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-258",
    d: "m449.26 105.78 6.14-6.14",
    className: "boat-layout_svg__cls-1"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-259",
    d: "m435.19 124.38 17.46-17.46",
    className: "boat-layout_svg__cls-1"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-260",
    d: "m453.99 105.58 4.37-4.37",
    className: "boat-layout_svg__cls-1"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-261",
    d: "m439.87 124.23 17.51-17.51",
    className: "boat-layout_svg__cls-1"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-262",
    d: "m458.72 105.38 2.59-2.59",
    className: "boat-layout_svg__cls-1"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-263",
    d: "m444.54 124.09 17.58-17.57",
    className: "boat-layout_svg__cls-1"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-264",
    d: "m463.46 105.18.81-.82",
    className: "boat-layout_svg__cls-1"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-265",
    d: "m449.21 123.96 17.64-17.64",
    className: "boat-layout_svg__cls-1"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-266",
    d: "m453.87 123.83 16.32-16.32",
    className: "boat-layout_svg__cls-1"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-267",
    d: "m458.53 123.71 14.62-14.62",
    className: "boat-layout_svg__cls-1"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-268",
    d: "m463.18 123.6 12.93-12.94",
    className: "boat-layout_svg__cls-1"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-269",
    d: "m467.82 123.49 11.25-11.25",
    className: "boat-layout_svg__cls-1"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-270",
    d: "m472.45 123.39 9.57-9.57",
    className: "boat-layout_svg__cls-1"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-271",
    d: "m477.08 123.29 7.9-7.9",
    className: "boat-layout_svg__cls-1"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-272",
    d: "m481.71 123.2 6.23-6.23",
    className: "boat-layout_svg__cls-1"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-273",
    d: "m486.32 123.12 4.58-4.58",
    className: "boat-layout_svg__cls-1"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-274",
    d: "m490.93 123.04 2.93-2.92",
    className: "boat-layout_svg__cls-1"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-275",
    d: "m495.54 122.97 1.28-1.28",
    className: "boat-layout_svg__cls-1"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-276",
    d: "m511.65 147.66 15.45-15.45",
    className: "boat-layout_svg__cls-1"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-277",
    d: "m506.94 147.84 15.49-15.49",
    className: "boat-layout_svg__cls-1"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-278",
    d: "m502.23 148.02 15.52-15.52",
    className: "boat-layout_svg__cls-1"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-279",
    d: "m497.51 148.2 15.55-15.55",
    className: "boat-layout_svg__cls-1"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-280",
    d: "m492.8 148.38 15.57-15.58",
    className: "boat-layout_svg__cls-1"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-281",
    d: "m488.09 148.56 15.59-15.6",
    className: "boat-layout_svg__cls-1"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-282",
    d: "m483.38 148.74 2.49-2.5",
    className: "boat-layout_svg__cls-1"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-283",
    d: "m490.55 141.56 8.44-8.44",
    className: "boat-layout_svg__cls-1"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-284",
    d: "m478.66 148.91 2.49-2.48",
    className: "boat-layout_svg__cls-1"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-285",
    d: "m489.79 137.78 4.5-4.49",
    className: "boat-layout_svg__cls-1"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-286",
    d: "m473.95 149.09 2.47-2.47",
    className: "boat-layout_svg__cls-1"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-287",
    d: "m487.29 135.75 2.3-2.29",
    className: "boat-layout_svg__cls-1"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-288",
    d: "m486.46 136.59.83-.84",
    className: "boat-layout_svg__cls-1"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-289",
    d: "m469.24 149.27 2.45-2.45",
    className: "boat-layout_svg__cls-1"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-290",
    d: "m481.73 136.78 3.15-3.15",
    className: "boat-layout_svg__cls-1"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-291",
    d: "m464.52 149.45 2.65-2.65",
    className: "boat-layout_svg__cls-1"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-292",
    d: "m477 136.97 3.17-3.16",
    className: "boat-layout_svg__cls-1"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-293",
    d: "m459.81 149.63 5.22-5.22",
    className: "boat-layout_svg__cls-1"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-294",
    d: "m472.27 137.17 3.19-3.19",
    className: "boat-layout_svg__cls-1"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-295",
    d: "m455.1 149.81 9.79-9.79",
    className: "boat-layout_svg__cls-1"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-296",
    d: "m467.52 137.39 3.22-3.22",
    className: "boat-layout_svg__cls-1"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-297",
    d: "m450.38 149.99 15.64-15.63",
    className: "boat-layout_svg__cls-1"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-298",
    d: "m445.67 150.17 15.62-15.62",
    className: "boat-layout_svg__cls-1"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-299",
    d: "m440.96 150.35 15.6-15.61",
    className: "boat-layout_svg__cls-1"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-300",
    d: "m436.24 150.53 15.4-15.4",
    className: "boat-layout_svg__cls-1"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-301",
    d: "m431.53 150.71 10.39-10.4",
    className: "boat-layout_svg__cls-1"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-302",
    d: "m426.82 150.89 5.39-5.4",
    className: "boat-layout_svg__cls-1"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-303",
    d: "m422.1 151.07.39-.39",
    className: "boat-layout_svg__cls-1"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-304",
    d: "m516.37 147.48 6.79-6.79",
    className: "boat-layout_svg__cls-1"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-305",
    d: "m529.47 134.37 2.31-2.3",
    className: "boat-layout_svg__cls-1"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-306",
    d: "m521.08 147.3 3.64-3.64",
    className: "boat-layout_svg__cls-1"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-307",
    d: "m534.2 134.18 2.25-2.25",
    className: "boat-layout_svg__cls-1"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-308",
    d: "m525.79 147.12 3.1-3.1",
    className: "boat-layout_svg__cls-1"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-309",
    d: "m538.93 133.99 2.18-2.19",
    className: "boat-layout_svg__cls-1"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-310",
    d: "m530.51 146.94 3.11-3.11",
    className: "boat-layout_svg__cls-1"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-311",
    d: "m545.35 132.1.43-.43",
    className: "boat-layout_svg__cls-1"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-312",
    d: "m543.66 133.79 1.69-1.69",
    className: "boat-layout_svg__cls-1"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-313",
    d: "m535.22 146.76 3.13-3.12",
    className: "boat-layout_svg__cls-1"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-314",
    d: "m547.52 134.46 2.92-2.91",
    className: "boat-layout_svg__cls-1"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-315",
    d: "m539.93 146.58 3.15-3.14",
    className: "boat-layout_svg__cls-1"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-316",
    d: "m548.72 137.8 6.37-6.38",
    className: "boat-layout_svg__cls-1"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-317",
    d: "m544.65 146.4.44-.44",
    className: "boat-layout_svg__cls-1"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-318",
    d: "m545.09 145.96 14.66-14.65",
    className: "boat-layout_svg__cls-1"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-319",
    d: "m549.36 146.23 15.03-15.04",
    className: "boat-layout_svg__cls-1"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-320",
    d: "m554.07 146.05 14.97-14.97",
    className: "boat-layout_svg__cls-1"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-321",
    d: "m558.79 145.87 14.89-14.9",
    className: "boat-layout_svg__cls-1"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-322",
    d: "m563.5 145.69 14.82-14.82",
    className: "boat-layout_svg__cls-1"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-323",
    d: "m568.21 145.51 14.74-14.74",
    className: "boat-layout_svg__cls-1"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-324",
    d: "m572.93 145.33 14.65-14.66",
    className: "boat-layout_svg__cls-1"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-325",
    d: "m577.64 145.15 8.26-8.27",
    className: "boat-layout_svg__cls-1"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-326",
    d: "m589.51 133.28 2.7-2.7",
    className: "boat-layout_svg__cls-1"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-327",
    d: "m582.35 144.97 3.94-3.94",
    className: "boat-layout_svg__cls-1"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-328",
    d: "m594.23 133.09 2.61-2.6",
    className: "boat-layout_svg__cls-1"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-329",
    d: "m587.06 144.79 1.89-1.88",
    className: "boat-layout_svg__cls-1"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-330",
    d: "m598.96 132.89 2.5-2.49",
    className: "boat-layout_svg__cls-1"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-331",
    d: "m591.78 144.61 1.87-1.87",
    className: "boat-layout_svg__cls-1"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-332",
    d: "m603.69 132.7 2.38-2.38",
    className: "boat-layout_svg__cls-1"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-333",
    d: "m596.49 144.43 1.89-1.89",
    className: "boat-layout_svg__cls-1"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-334",
    d: "m601.2 144.25 1.91-1.9",
    className: "boat-layout_svg__cls-1"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-335",
    d: "m605.92 144.07 1.92-1.91",
    className: "boat-layout_svg__cls-1"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-336",
    d: "m638.91 142.82 13.15-13.15",
    className: "boat-layout_svg__cls-1"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-337",
    d: "m634.2 143 13.28-13.28",
    className: "boat-layout_svg__cls-1"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-338",
    d: "m629.48 143.18 13.41-13.41",
    className: "boat-layout_svg__cls-1"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-339",
    d: "m624.77 143.36 13.53-13.53",
    className: "boat-layout_svg__cls-1"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-340",
    d: "m620.06 143.54 13.65-13.65",
    className: "boat-layout_svg__cls-1"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-341",
    d: "m615.34 143.72 13.77-13.77",
    className: "boat-layout_svg__cls-1"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-342",
    d: "m610.63 143.9 13.88-13.88",
    className: "boat-layout_svg__cls-1"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-343",
    d: "m611.62 138.37 8.29-8.28",
    className: "boat-layout_svg__cls-1"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-344",
    d: "m611.18 134.28 4.12-4.12",
    className: "boat-layout_svg__cls-1"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-345",
    d: "m608.41 132.51 2.28-2.27",
    className: "boat-layout_svg__cls-1"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-346",
    d: "m643.62 142.64 13.02-13.02",
    className: "boat-layout_svg__cls-1"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-347",
    d: "m648.34 142.46 4.48-4.48",
    className: "boat-layout_svg__cls-1"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-348",
    d: "m658.78 132.02 2.44-2.44",
    className: "boat-layout_svg__cls-1"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-349",
    d: "m653.05 142.28 1.65-1.65",
    className: "boat-layout_svg__cls-1"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-350",
    d: "m663.5 131.83 2.29-2.29",
    className: "boat-layout_svg__cls-1"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-351",
    d: "m657.76 142.1 1.44-1.43",
    className: "boat-layout_svg__cls-1"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-352",
    d: "m668.23 131.63 2.13-2.12",
    className: "boat-layout_svg__cls-1"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-353",
    d: "m662.47 141.92 1.46-1.45",
    className: "boat-layout_svg__cls-1"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-354",
    d: "m667.19 141.74 1.46-1.46",
    className: "boat-layout_svg__cls-1"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-355",
    d: "m671.9 141.57 1.31-1.32",
    className: "boat-layout_svg__cls-1"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-356",
    d: "m756.74 138.34 8.86-8.86",
    className: "boat-layout_svg__cls-1"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-357",
    d: "m752.02 138.52 9.04-9.04",
    className: "boat-layout_svg__cls-1"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-358",
    d: "m747.31 138.7 9.25-9.25",
    className: "boat-layout_svg__cls-1"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-359",
    d: "m742.6 138.88 9.45-9.46",
    className: "boat-layout_svg__cls-1"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-360",
    d: "m737.89 139.06 9.65-9.66",
    className: "boat-layout_svg__cls-1"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-361",
    d: "m733.17 139.23 9.86-9.85",
    className: "boat-layout_svg__cls-1"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-362",
    d: "m728.46 139.41 10.05-10.04",
    className: "boat-layout_svg__cls-1"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-363",
    d: "m723.75 139.59 10.24-10.24",
    className: "boat-layout_svg__cls-1"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-364",
    d: "m719.03 139.77 10.43-10.43",
    className: "boat-layout_svg__cls-1"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-365",
    d: "m714.32 139.95 10.62-10.62",
    className: "boat-layout_svg__cls-1"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-366",
    d: "m709.61 140.13 10.8-10.8",
    className: "boat-layout_svg__cls-1"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-367",
    d: "m704.89 140.31 10.98-10.98",
    className: "boat-layout_svg__cls-1"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-368",
    d: "m700.18 140.49 11.16-11.16",
    className: "boat-layout_svg__cls-1"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-369",
    d: "m695.47 140.67 11.33-11.33",
    className: "boat-layout_svg__cls-1"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-370",
    d: "m690.75 140.85 11.5-11.5",
    className: "boat-layout_svg__cls-1"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-371",
    d: "m686.04 141.03 11.67-11.67",
    className: "boat-layout_svg__cls-1"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-372",
    d: "m681.33 141.21 11.83-11.83",
    className: "boat-layout_svg__cls-1"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-373",
    d: "m676.61 141.39 11.99-11.99",
    className: "boat-layout_svg__cls-1"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-374",
    d: "m673.21 140.25.19-.18",
    className: "boat-layout_svg__cls-1"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-375",
    d: "m675.86 137.61 8.19-8.19",
    className: "boat-layout_svg__cls-1"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-376",
    d: "m675.6 133.33 3.89-3.89",
    className: "boat-layout_svg__cls-1"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-377",
    d: "m672.95 131.44 1.98-1.97",
    className: "boat-layout_svg__cls-1"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-378",
    d: "m761.45 138.16 8.73-8.72",
    className: "boat-layout_svg__cls-1"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-379",
    d: "m766.16 137.98 8.59-8.59",
    className: "boat-layout_svg__cls-1"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-380",
    d: "m770.88 137.8 8.45-8.45",
    className: "boat-layout_svg__cls-1"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-381",
    d: "m775.59 137.62 8.31-8.31",
    className: "boat-layout_svg__cls-1"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-382",
    d: "m780.3 137.44 8.18-8.17",
    className: "boat-layout_svg__cls-1"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-383",
    d: "m785.02 137.26 8.03-8.03",
    className: "boat-layout_svg__cls-1"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-384",
    d: "m789.73 137.08 7.9-7.89",
    className: "boat-layout_svg__cls-1"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-385",
    d: "m794.44 136.9 7.76-7.76",
    className: "boat-layout_svg__cls-1"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-386",
    d: "m799.16 136.73 7.62-7.63",
    className: "boat-layout_svg__cls-1"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-387",
    d: "m803.87 136.55 7.49-7.49",
    className: "boat-layout_svg__cls-1"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-388",
    d: "m808.58 136.37 7.35-7.35",
    className: "boat-layout_svg__cls-1"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-389",
    d: "m813.3 136.19 7.21-7.21",
    className: "boat-layout_svg__cls-1"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-390",
    d: "m818.01 136.01 7.07-7.07",
    className: "boat-layout_svg__cls-1"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-391",
    d: "m822.72 135.83 6.94-6.94",
    className: "boat-layout_svg__cls-1"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-392",
    d: "m827.44 135.65 6.79-6.8",
    className: "boat-layout_svg__cls-1"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-393",
    d: "m832.15 135.47 6.66-6.66",
    className: "boat-layout_svg__cls-1"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-394",
    d: "m836.86 135.29 6.52-6.52",
    className: "boat-layout_svg__cls-1"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-395",
    d: "m407.75 174.49 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-396",
    d: "m403 174.7 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-397",
    d: "m398.26 174.91 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-398",
    d: "m393.51 175.13 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-399",
    d: "m388.76 175.34 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-400",
    d: "m384.01 175.56 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-401",
    d: "m379.26 175.77 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-402",
    d: "m374.52 175.98 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-403",
    d: "m369.77 176.2 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-404",
    d: "m365.02 176.41 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-405",
    d: "m360.27 176.63 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-406",
    d: "m355.53 176.84 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-407",
    d: "m350.78 177.05 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-408",
    d: "m346.03 177.27 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-409",
    d: "m341.28 177.48 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-410",
    d: "m336.53 177.69 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-411",
    d: "m331.79 177.91 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-412",
    d: "m327.04 178.12 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-413",
    d: "m322.29 178.34 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-414",
    d: "m317.54 178.55 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-415",
    d: "m312.8 178.76 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-416",
    d: "m308.05 178.98 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-417",
    d: "m303.3 179.19 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-418",
    d: "m298.55 179.41 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-419",
    d: "m293.8 179.62 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-420",
    d: "m289.06 179.83 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-421",
    d: "m284.31 180.05 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-422",
    d: "m279.56 180.26 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-423",
    d: "m274.81 180.47 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-424",
    d: "m270.07 180.69 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-425",
    d: "m265.32 180.9 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-426",
    d: "m260.57 181.12 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-427",
    d: "m255.82 181.33 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-428",
    d: "m251.07 181.54 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-429",
    d: "m246.33 181.76 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-430",
    d: "m241.58 181.97 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-431",
    d: "m236.83 182.19 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-432",
    d: "m232.08 182.4 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-433",
    d: "m227.34 182.61 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-434",
    d: "m222.59 182.83 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-435",
    d: "m217.84 183.04 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-436",
    d: "m213.09 183.26 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-437",
    d: "m208.35 183.47 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-438",
    d: "m203.6 183.68 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-439",
    d: "m198.85 183.9 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-440",
    d: "m194.1 184.11 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-441",
    d: "m189.35 184.32 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-442",
    d: "m184.61 184.54 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-443",
    d: "m179.86 184.75 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-444",
    d: "m175.11 184.97 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-445",
    d: "m170.36 185.18 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-446",
    d: "m165.62 185.39 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-447",
    d: "m160.87 185.61 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-448",
    d: "m156.12 185.82 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-449",
    d: "m146.41 191 15.04-15.05",
    className: "boat-layout_svg__cls-1"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-450",
    d: "m127 205.87 29.71-29.7",
    className: "boat-layout_svg__cls-1"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-451",
    d: "m111.46 216.88 40.5-40.5",
    className: "boat-layout_svg__cls-1"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-452",
    d: "m106.55 217.26 40.66-40.66",
    className: "boat-layout_svg__cls-1"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-453",
    d: "m101.64 217.63 40.82-40.82",
    className: "boat-layout_svg__cls-1"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-454",
    d: "m96.73 218.01 40.98-40.99",
    className: "boat-layout_svg__cls-1"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-455",
    d: "m91.82 218.39 41.15-41.15",
    className: "boat-layout_svg__cls-1"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-456",
    d: "m86.91 218.76 41.31-41.31",
    className: "boat-layout_svg__cls-1"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-457",
    d: "m81.99 219.14 41.48-41.48",
    className: "boat-layout_svg__cls-1"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-458",
    d: "m77.08 219.52 38.82-38.82",
    className: "boat-layout_svg__cls-1"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-459",
    d: "m72.17 219.9 24.32-24.32",
    className: "boat-layout_svg__cls-1"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-460",
    d: "m67.26 220.27 9.82-9.82",
    className: "boat-layout_svg__cls-1"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-461",
    d: "m62.35 220.65 6.97-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-462",
    d: "m57.44 221.03 6.97-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-463",
    d: "m52.53 221.4 6.96-6.96",
    className: "boat-layout_svg__cls-1"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-464",
    d: "m47.62 221.78 6.96-6.96",
    className: "boat-layout_svg__cls-1"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-465",
    d: "m42.71 222.16 6.96-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-466",
    d: "m37.8 222.53 6.96-6.96",
    className: "boat-layout_svg__cls-1"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-467",
    d: "m32.89 222.91 6.96-6.96",
    className: "boat-layout_svg__cls-1"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-468",
    d: "m27.97 223.29 6.97-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-469",
    d: "m23.06 223.67 6.97-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-470",
    d: "m18.15 224.04 6.97-6.96",
    className: "boat-layout_svg__cls-1"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-471",
    d: "m13.24 224.42 6.97-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-472",
    d: "m8.33 224.8 6.97-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-473",
    d: "m4.71 223.89 5.68-5.68",
    className: "boat-layout_svg__cls-1"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-474",
    d: "m1.68 222.38 3.88-3.88",
    className: "boat-layout_svg__cls-1"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-475",
    d: "m412.5 174.27 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-476",
    d: "m417.25 174.06 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-477",
    d: "m421.99 173.85 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-478",
    d: "m426.74 173.63 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-479",
    d: "m431.49 173.42 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-480",
    d: "m436.24 173.2 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-481",
    d: "m440.99 172.99 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-482",
    d: "m445.73 172.78 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-483",
    d: "m450.48 172.56 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-484",
    d: "m455.23 172.35 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-485",
    d: "m459.98 172.13 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-486",
    d: "m464.72 171.92 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-487",
    d: "m469.47 171.71 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-488",
    d: "m474.22 171.49 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-489",
    d: "m478.97 171.28 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-490",
    d: "m483.72 171.06 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-491",
    d: "m488.46 170.85 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-492",
    d: "m493.21 170.64 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-493",
    d: "m497.96 170.42 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-494",
    d: "m502.71 170.21 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-495",
    d: "m507.45 170 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-496",
    d: "m512.2 169.78 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-497",
    d: "m516.95 169.57 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-498",
    d: "m521.7 169.35 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-499",
    d: "m526.45 169.14 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-500",
    d: "m531.19 168.93 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-501",
    d: "m535.94 168.71 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-502",
    d: "m540.69 168.5 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-503",
    d: "m545.44 168.28 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-504",
    d: "m550.18 168.07 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-505",
    d: "m554.93 167.86 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-506",
    d: "m559.68 167.64 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-507",
    d: "m564.43 167.43 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-508",
    d: "m569.17 167.22 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-509",
    d: "M573.92 167 584 156.92",
    className: "boat-layout_svg__cls-1"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-510",
    d: "m578.67 166.79 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-511",
    d: "m583.42 166.57 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-512",
    d: "m588.17 166.36 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-513",
    d: "M592.91 166.15 603 156.06",
    className: "boat-layout_svg__cls-1"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-514",
    d: "m597.66 165.93 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-515",
    d: "m602.41 165.72 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-516",
    d: "m607.16 165.5 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-517",
    d: "m611.9 165.29 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-518",
    d: "m616.65 165.08 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-519",
    d: "m621.4 164.86 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-520",
    d: "m626.15 164.65 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-521",
    d: "m630.9 164.44 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-522",
    d: "m635.64 164.22 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-523",
    d: "m640.39 164.01 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-524",
    d: "m645.14 163.79 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-525",
    d: "m649.89 163.58 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-526",
    d: "m654.63 163.37 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-527",
    d: "m659.38 163.15 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-528",
    d: "m664.13 162.94 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-529",
    d: "m668.88 162.72 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-530",
    d: "m673.63 162.51 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-531",
    d: "m678.37 162.3 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-532",
    d: "M683.12 162.08 693.2 152",
    className: "boat-layout_svg__cls-1"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-533",
    d: "m687.87 161.87 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-534",
    d: "m692.62 161.65 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-535",
    d: "m697.36 161.44 10.09-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-536",
    d: "m702.11 161.23 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-537",
    d: "m706.86 161.01 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-538",
    d: "m711.61 160.8 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-539",
    d: "m716.36 160.59 10.08-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-540",
    d: "m721.1 160.37 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-541",
    d: "m725.85 160.16 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-542",
    d: "m730.6 159.94 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-543",
    d: "m735.35 159.73 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-544",
    d: "m740.09 159.52 10.09-10.09",
    className: "boat-layout_svg__cls-1"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-545",
    d: "m744.84 159.3 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-546",
    d: "m749.59 159.09 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-547",
    d: "m754.34 158.87 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-548",
    d: "m759.09 158.66 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-549",
    d: "m763.83 158.45 10.08-10.08",
    className: "boat-layout_svg__cls-1"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-550",
    d: "m772.72 154.09 5.94-5.94",
    className: "boat-layout_svg__cls-1"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-551",
    d: "M.35 220.52v-.09",
    className: "boat-layout_svg__cls-1"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-552",
    d: "m64.47 226.52-57.7-1.6",
    className: "boat-layout_svg__cls-1"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-553",
    d: "m6.77 224.92-5.35-2.68",
    className: "boat-layout_svg__cls-1"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-554",
    d: "M6.77 218.5H2.28",
    className: "boat-layout_svg__cls-1"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-191",
    d: "M2.28 218.5c-1.06 0-1.92.86-1.92 1.92",
    className: "boat-layout_svg__cls-1"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-192",
    d: "M.35 220.52c0 .73.41 1.39 1.06 1.72",
    className: "boat-layout_svg__cls-1"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-555",
    d: "m6.77 218.5 64.12-38.47",
    className: "boat-layout_svg__cls-1"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-556",
    d: "m64.47 226.52 2.96 4.81",
    className: "boat-layout_svg__cls-1"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-557",
    d: "m750.55 167.82 32.06-19.85",
    className: "boat-layout_svg__cls-1"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-558",
    d: "m693.33 199.27-45.37 32.06",
    className: "boat-layout_svg__cls-1"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-559",
    d: "m697.4 198.46 48.97-30.32",
    className: "boat-layout_svg__cls-1"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-560",
    d: "m80.28 169.98 47.37-2.13",
    className: "boat-layout_svg__cls-1"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-561",
    d: "m70.89 180.03.72-4.84",
    className: "boat-layout_svg__cls-1"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-562",
    d: "m71.61 175.19 8.67-5.21",
    className: "boat-layout_svg__cls-1"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-563",
    d: "m127.65 167.85 8.67-5.21",
    className: "boat-layout_svg__cls-1"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-564",
    d: "m136.32 162.64 101.27-4.56",
    className: "boat-layout_svg__cls-1"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-565",
    d: "m237.59 158.08 48.09-25.65",
    className: "boat-layout_svg__cls-1"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-193",
    d: "M763.37 129.5c-15.6-.99-31.2-1.87-46.81-2.65",
    className: "boat-layout_svg__cls-1"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-566",
    d: "m207.83 159.42 71.82-38.3",
    className: "boat-layout_svg__cls-1"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-567",
    d: "m266.94 156.97 24.78-13.22",
    className: "boat-layout_svg__cls-1"
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-568",
    d: "m782.61 147.97 57.98-12.82",
    className: "boat-layout_svg__cls-1"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-569",
    d: "m840.59 135.15 6.14-6.41",
    className: "boat-layout_svg__cls-1"
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-570",
    d: "M789.97 146.34v-1.5",
    className: "boat-layout_svg__cls-1"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-194",
    d: "M789.97 144.84c0-1.06-.86-1.92-1.92-1.92h-.09",
    className: "boat-layout_svg__cls-1"
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-571",
    d: "m266.94 156.97 573.65-21.82",
    className: "boat-layout_svg__cls-1"
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-572",
    d: "m846.73 128.74-83.36.76",
    className: "boat-layout_svg__cls-1"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-195",
    d: "M763.37 129.5a6294 6294 0 0 0-471.65 14.25",
    className: "boat-layout_svg__cls-1"
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-573",
    d: "m421.74 151.08 30.28-16.15",
    className: "boat-layout_svg__cls-1"
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-574",
    d: "m279.65 121.12-11.72-28.19",
    className: "boat-layout_svg__cls-1"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-575",
    d: "m299.4 90.65 50.19 37.54",
    className: "boat-layout_svg__cls-1"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-576",
    d: "M269.71 90.27h28.54",
    className: "boat-layout_svg__cls-1"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-196",
    d: "M269.71 90.27a1.92 1.92 0 0 0-1.77 2.66",
    className: "boat-layout_svg__cls-1"
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-197",
    d: "M299.4 90.65c-.33-.25-.74-.38-1.15-.38",
    className: "boat-layout_svg__cls-1"
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-577",
    d: "m270.11 98.16-32.6-4.98",
    className: "boat-layout_svg__cls-1"
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-578",
    d: "m448.03 81.48 4.05-3.35",
    className: "boat-layout_svg__cls-1"
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-579",
    d: "M451.11 74.74 362.47 62.8",
    className: "boat-layout_svg__cls-1"
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-580",
    d: "m425.05 83.48 74.08 39.44",
    className: "boat-layout_svg__cls-1"
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-581",
    d: "m448.03 81.48 60.04 31.66",
    className: "boat-layout_svg__cls-1"
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-582",
    d: "m237.8 87.06 22.46-9.58",
    className: "boat-layout_svg__cls-1"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-583",
    d: "M260.74 77.34 362.47 62.8",
    className: "boat-layout_svg__cls-1"
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-198",
    d: "M452.08 78.13c.82-.68.93-1.89.25-2.71-.31-.37-.75-.61-1.22-.68",
    className: "boat-layout_svg__cls-1"
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-199",
    d: "M260.74 77.34c-.17.02-.33.07-.48.14",
    className: "boat-layout_svg__cls-1"
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-584",
    d: "m237.51 93.18 26.8-6.97",
    className: "boat-layout_svg__cls-1"
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-585",
    d: "m264.31 86.21 108.76-8.95",
    className: "boat-layout_svg__cls-1"
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-586",
    d: "m373.07 77.26 74.96 4.22",
    className: "boat-layout_svg__cls-1"
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-587",
    d: "m303.88 94 144.15-12.52",
    className: "boat-layout_svg__cls-1"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-588",
    d: "m336.35 118.29 71.9-33.35",
    className: "boat-layout_svg__cls-1"
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-200",
    d: "M520.12 119.5c-4.8.04-9.61.08-14.41.14",
    className: "boat-layout_svg__cls-1"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-201",
    d: "M499.13 122.92c-40.95.55-81.89 1.84-122.79 3.85",
    className: "boat-layout_svg__cls-1"
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-589",
    d: "m362.47 62.8 4.4-7.25",
    className: "boat-layout_svg__cls-1"
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-590",
    d: "m369.15 54.73 30.21 10.55",
    className: "boat-layout_svg__cls-1"
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-591",
    d: "m400.65 67.05.03.9",
    className: "boat-layout_svg__cls-1"
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-202",
    d: "M400.65 67.05c-.02-.8-.54-1.5-1.29-1.76",
    className: "boat-layout_svg__cls-1"
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-203",
    d: "M369.15 54.73c-.86-.3-1.81.04-2.28.82",
    className: "boat-layout_svg__cls-1"
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-592",
    d: "M260.26 77.48 205.54.5",
    className: "boat-layout_svg__cls-1"
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-593",
    d: "M205.54.5h19.23",
    className: "boat-layout_svg__cls-1"
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-594",
    d: "m224.77.5 89.97 69.12",
    className: "boat-layout_svg__cls-1"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-595",
    d: "m218.46.5 90.96 69.88",
    className: "boat-layout_svg__cls-1"
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-596",
    d: "M274.5 75.37 224.65 5.26",
    className: "boat-layout_svg__cls-1"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-597",
    d: "M224.65 5.26h6.32",
    className: "boat-layout_svg__cls-1"
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-598",
    d: "M239.72 48.59h47.64",
    className: "boat-layout_svg__cls-1"
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-599",
    d: "M262.29 58.21h37.59",
    className: "boat-layout_svg__cls-1"
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-600",
    d: "m256.24 79.19-4.9-8.67",
    className: "boat-layout_svg__cls-1"
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-204",
    d: "M251.34 70.52a5.6 5.6 0 0 0-7.82 1.26c-.14.19-.27.39-.38.6",
    className: "boat-layout_svg__cls-1"
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-601",
    d: "m216.2 138.8 19.18-47.27",
    className: "boat-layout_svg__cls-1"
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-205",
    d: "M237.8 87.06c-1.7.2-2.92 1.74-2.73 3.44.15 1.32 1.13 2.4 2.43 2.68",
    className: "boat-layout_svg__cls-1"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-602",
    d: "m237.12 87.22 6.02-14.84",
    className: "boat-layout_svg__cls-1"
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-603",
    d: "m214.45 155.89 25.38-62.56",
    className: "boat-layout_svg__cls-1"
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-604",
    d: "m243.34 84.7 4.26-10.51",
    className: "boat-layout_svg__cls-1"
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-605",
    d: "m257.91 78.24-3.21-5.69",
    className: "boat-layout_svg__cls-1"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-206",
    d: "M249.77 71.73c-.82.73-1.55 1.56-2.18 2.46",
    className: "boat-layout_svg__cls-1"
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-207",
    d: "M254.7 72.55a3.212 3.212 0 0 0-4.93-.82",
    className: "boat-layout_svg__cls-1"
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-606",
    d: "m216.2 138.8 8.86-.52",
    className: "boat-layout_svg__cls-1"
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-607",
    d: "m223.35 121.18 8.86-.52",
    className: "boat-layout_svg__cls-1"
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-608",
    d: "m230.5 103.55 8.84-.52",
    className: "boat-layout_svg__cls-1"
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-208",
    d: "M651.16 124.22c-41.66-1.28-83.35-1.8-125.03-1.56",
    className: "boat-layout_svg__cls-1"
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-209",
    d: "M715.28 126.79c-20.94-1.03-41.88-1.87-62.84-2.52",
    className: "boat-layout_svg__cls-1"
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-210",
    d: "M504.4 119.65c-3.71.04-7.43.09-11.14.15",
    className: "boat-layout_svg__cls-1"
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-609",
    d: "m509.25 113.76 16.88 8.9",
    className: "boat-layout_svg__cls-1"
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-211",
    d: "M374.98 126.84c-29.79 1.48-59.55 3.34-89.29 5.6",
    className: "boat-layout_svg__cls-1"
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-610",
    d: "M647.96 231.33H67.43",
    className: "boat-layout_svg__cls-1"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-611",
    d: "m70.89 180.03 711.72-32.06",
    className: "boat-layout_svg__cls-1"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-612",
    d: "m532.54 231.33 164.86-32.87",
    className: "boat-layout_svg__cls-1"
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-613",
    d: "m112.77 216.78-106 8.14",
    className: "boat-layout_svg__cls-1"
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-614",
    d: "m71.61 175.19 716.35-32.27",
    className: "boat-layout_svg__cls-1"
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-615",
    d: "m425.05 83.48-10.4 41.62",
    className: "boat-layout_svg__cls-1"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-616",
    d: "m372.9 88.01-9.86 39.44",
    className: "boat-layout_svg__cls-1"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-617",
    d: "m204.31 159.58 31.72-78.2",
    className: "boat-layout_svg__cls-1"
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-618",
    d: "m218.87 153.54 23.93-59",
    className: "boat-layout_svg__cls-1"
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-212",
    d: "M240.68 78.46c-1.95.1-3.71 1.2-4.64 2.92",
    className: "boat-layout_svg__cls-1"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-619",
    d: "m264.31 73.59 97.7-13.96",
    className: "boat-layout_svg__cls-1"
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-620",
    d: "m262.89 77.03 1.42-3.44",
    className: "boat-layout_svg__cls-1"
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-621",
    d: "m362.01 59.63 10.5 4.52",
    className: "boat-layout_svg__cls-1"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-622",
    d: "m269.4 76.1-2.26-7.09",
    className: "boat-layout_svg__cls-1"
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-623",
    d: "m317.7 69.2-.46-3.17",
    className: "boat-layout_svg__cls-1"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-624",
    d: "m344.21 65.41-.45-3.17",
    className: "boat-layout_svg__cls-1"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-625",
    d: "m341.04 65.86-.46-3.17",
    className: "boat-layout_svg__cls-1"
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-626",
    d: "m392.75 109.45 60-2.54",
    className: "boat-layout_svg__cls-1"
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-627",
    d: "M814.67 128.74v-6.12",
    className: "boat-layout_svg__cls-1"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-628",
    d: "m814.67 122.62 32.06-32.35",
    className: "boat-layout_svg__cls-1"
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-629",
    d: "m811.46 121.3 30.55-30.83",
    className: "boat-layout_svg__cls-1"
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-630",
    d: "M811.46 128.74v-7.44",
    className: "boat-layout_svg__cls-1"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-631",
    d: "M766.58 129.47v-8.17",
    className: "boat-layout_svg__cls-1"
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-632",
    d: "M772.99 129.41v-8.11",
    className: "boat-layout_svg__cls-1"
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-633",
    d: "m766.58 121.3 28.59-28.85",
    className: "boat-layout_svg__cls-1"
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-634",
    d: "m772.99 121.3 28.87-29.14",
    className: "boat-layout_svg__cls-1"
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-635",
    d: "M702.46 126.18v-6.42",
    className: "boat-layout_svg__cls-1"
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-636",
    d: "M715.28 128.56v-8.19",
    className: "boat-layout_svg__cls-1"
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-637",
    d: "m702.46 119.76 24.2-24.42",
    className: "boat-layout_svg__cls-1"
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-638",
    d: "m715.28 120.37 25.39-25.62",
    className: "boat-layout_svg__cls-1"
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-639",
    d: "M651.16 128.24v-10.43",
    className: "boat-layout_svg__cls-1"
  })), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-640",
    d: "M635.13 123.77v-6.41",
    className: "boat-layout_svg__cls-1"
  })), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-641",
    d: "m635.13 117.36 18.77-18.95",
    className: "boat-layout_svg__cls-1"
  })), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-642",
    d: "m651.16 117.81 19.94-20.12",
    className: "boat-layout_svg__cls-1"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-643",
    d: "M583.84 128.24v-10.88",
    className: "boat-layout_svg__cls-1"
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-644",
    d: "m583.84 116.4 15.54-15.68",
    className: "boat-layout_svg__cls-1"
  })), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-645",
    d: "m567.81 115.95 14.37-14.51",
    className: "boat-layout_svg__cls-1"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-646",
    d: "M583.84 122.82v-6.42",
    className: "boat-layout_svg__cls-1"
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-647",
    d: "M567.81 122.68v-6.73",
    className: "boat-layout_svg__cls-1"
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-648",
    d: "m505.04 116.2 11.88-12",
    className: "boat-layout_svg__cls-1"
  })), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-649",
    d: "m440.32 121.28 14.32-14.45",
    className: "boat-layout_svg__cls-1"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-650",
    d: "m377.18 123.95 13.43-13.55",
    className: "boat-layout_svg__cls-1"
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-651",
    d: "m374.36 133.34 2.82-9.39",
    className: "boat-layout_svg__cls-1"
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-213",
    d: "M392.75 109.45c-.81.03-1.57.37-2.14.95",
    className: "boat-layout_svg__cls-1"
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-652",
    d: "m440.32 121.28-2.61 9.08",
    className: "boat-layout_svg__cls-1"
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-653",
    d: "m505.04 116.2-2.12 11.56",
    className: "boat-layout_svg__cls-1"
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-654",
    d: "m152.98 185.96 612.85-27.6",
    className: "boat-layout_svg__cls-1"
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-655",
    d: "m152.98 185.96-40.21 30.82",
    className: "boat-layout_svg__cls-1"
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-656",
    d: "m119.64 177.84-46.38 35.54",
    className: "boat-layout_svg__cls-1"
  })), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-657",
    d: "m73.26 213.38-66.98 5.14",
    className: "boat-layout_svg__cls-1"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE",
    d: "M304.09 114.28c.53-.64.91-1.39 1.12-2.19.22-.85.27-1.75.13-2.62s-.44-1.74-.89-2.51c-.48-.82-1.09-1.55-1.82-2.15s-1.56-1.07-2.45-1.38c-.85-.3-1.74-.43-2.63-.4s-1.75.25-2.55.63c-.75.36-1.41.87-1.94 1.51s-.91 1.39-1.12 2.19c-.22.85-.27 1.75-.13 2.62s.44 1.74.89 2.51c.48.82 1.09 1.55 1.82 2.15s1.56 1.07 2.45 1.38c.85.3 1.74.43 2.63.4s1.75-.25 2.55-.63c.75-.36 1.41-.87 1.94-1.51",
    className: "boat-layout_svg__cls-1"
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-658",
    d: "M746.37 168.14 91.13 231.33",
    className: "boat-layout_svg__cls-1"
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-2",
    d: "M464.97 143.87a3.2 3.2 0 0 0 3.32 3.08h.01l19.22-.79a3.203 3.203 0 0 0 3.07-3.32l-.12-3.2a3.2 3.2 0 0 0-3.32-3.08h-.01l-19.22.79a3.203 3.203 0 0 0-3.07 3.32z",
    className: "boat-layout_svg__cls-1"
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-3",
    d: "M466.25 143.83c.04 1.06.93 1.89 1.99 1.85q0 0 0 0l19.22-.79c1.06-.04 1.88-.93 1.84-1.99l-.12-3.2a1.92 1.92 0 0 0-1.99-1.85s0 0 0 0l-19.22.79c-1.06.04-1.88.93-1.84 1.99z",
    className: "boat-layout_svg__cls-1"
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-4",
    d: "M523.17 141.04a3.2 3.2 0 0 0 3.32 3.08h.01l19.22-.79a3.203 3.203 0 0 0 3.07-3.32l-.12-3.2a3.2 3.2 0 0 0-3.32-3.08h-.01l-19.22.79a3.203 3.203 0 0 0-3.07 3.32z",
    className: "boat-layout_svg__cls-1"
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-5",
    d: "M524.45 140.99c.04 1.06.93 1.89 1.99 1.85q0 0 0 0l19.22-.79c1.06-.04 1.88-.93 1.84-1.99l-.12-3.2a1.92 1.92 0 0 0-1.99-1.85s0 0 0 0l-19.22.79c-1.06.04-1.88.93-1.84 1.99z",
    className: "boat-layout_svg__cls-1"
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-6",
    d: "m585.9 136.63.12 3.2a3.2 3.2 0 0 0 3.32 3.08h.01l19.22-.79a3.203 3.203 0 0 0 3.07-3.32l-.12-3.2a3.2 3.2 0 0 0-3.32-3.08h-.01l-19.22.79a3.203 3.203 0 0 0-3.07 3.32",
    className: "boat-layout_svg__cls-1"
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-7",
    d: "m587.18 136.58.12 3.2c.04 1.06.93 1.89 1.99 1.85q0 0 0 0l19.22-.79c1.06-.04 1.88-.93 1.84-1.99l-.12-3.2a1.92 1.92 0 0 0-1.99-1.85s0 0 0 0l-19.22.79c-1.06.04-1.88.93-1.84 1.99",
    className: "boat-layout_svg__cls-1"
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-8",
    d: "m655.82 140.81 17.3-.71c1.59-.07 2.82-1.4 2.77-2.99l-.11-2.88a2.89 2.89 0 0 0-2.99-2.78h-.01l-17.3.71c-1.59.07-2.82 1.4-2.77 2.99l.11 2.88c.06 1.59 1.4 2.84 2.99 2.78z",
    className: "boat-layout_svg__cls-1"
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LWPOLYLINE-9",
    d: "m655.77 139.52 17.3-.71c.88-.04 1.57-.78 1.54-1.66l-.11-2.88a1.6 1.6 0 0 0-1.66-1.54s0 0 0 0l-17.3.71c-.88.04-1.57.78-1.54 1.66l.11 2.88a1.6 1.6 0 0 0 1.66 1.54s0 0 0 0",
    className: "boat-layout_svg__cls-1"
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-659",
    d: "M392.7 108.17 872.25 87.9",
    className: "boat-layout_svg__cls-1"
  })), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-660",
    d: "m815.95 123.15 32.66-32.96",
    className: "boat-layout_svg__cls-1"
  })), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-661",
    d: "M815.95 128.74v-5.59",
    className: "boat-layout_svg__cls-1"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-662",
    d: "m810.18 120.77 29.95-30.22",
    className: "boat-layout_svg__cls-1"
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-663",
    d: "M810.18 128.74v-7.97",
    className: "boat-layout_svg__cls-1"
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-664",
    d: "m774.27 121.83 29.48-29.75",
    className: "boat-layout_svg__cls-1"
  })), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-665",
    d: "M774.27 129.41v-7.58",
    className: "boat-layout_svg__cls-1"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-666",
    d: "M765.29 129.47v-8.7",
    className: "boat-layout_svg__cls-1"
  })), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-667",
    d: "m765.29 120.77 28-28.25",
    className: "boat-layout_svg__cls-1"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-668",
    d: "m872.25 87.9.05 1.29",
    className: "boat-layout_svg__cls-1"
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-669",
    d: "m848.61 90.19 23.69-1",
    className: "boat-layout_svg__cls-1"
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-670",
    d: "m803.75 92.08 42.98-1.81",
    className: "boat-layout_svg__cls-1"
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-671",
    d: "m716.56 120.9 25.99-26.23",
    className: "boat-layout_svg__cls-1"
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-672",
    d: "M716.56 128.56v-7.66",
    className: "boat-layout_svg__cls-1"
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-673",
    d: "m703.74 120.29 24.8-25.03",
    className: "boat-layout_svg__cls-1"
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-674",
    d: "M703.74 126.18v-5.89",
    className: "boat-layout_svg__cls-1"
  })), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-675",
    d: "m652.44 118.34 20.55-20.73",
    className: "boat-layout_svg__cls-1"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-676",
    d: "M652.44 128.24v-9.9",
    className: "boat-layout_svg__cls-1"
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-677",
    d: "m636.41 117.88 19.38-19.55",
    className: "boat-layout_svg__cls-1"
  })), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-678",
    d: "M636.41 123.77v-5.89",
    className: "boat-layout_svg__cls-1"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-679",
    d: "M651.16 128.24h1.28",
    className: "boat-layout_svg__cls-1"
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-680",
    d: "M715.28 128.56h1.28",
    className: "boat-layout_svg__cls-1"
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-681",
    d: "m742.55 94.67 59.31-2.51",
    className: "boat-layout_svg__cls-1"
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-682",
    d: "m672.99 97.61 67.68-2.86",
    className: "boat-layout_svg__cls-1"
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-683",
    d: "m585.12 116.93 16.15-16.29",
    className: "boat-layout_svg__cls-1"
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-684",
    d: "M585.12 128.24v-11.31",
    className: "boat-layout_svg__cls-1"
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-685",
    d: "m569.09 116.48 14.98-15.11",
    className: "boat-layout_svg__cls-1"
  })), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-686",
    d: "M569.09 122.68v-6.2",
    className: "boat-layout_svg__cls-1"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-687",
    d: "m506.23 116.82 12.58-12.7",
    className: "boat-layout_svg__cls-1"
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-688",
    d: "m506.23 116.82-2.05 11.17",
    className: "boat-layout_svg__cls-1"
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-689",
    d: "m502.92 127.76 1.26.23",
    className: "boat-layout_svg__cls-1"
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-690",
    d: "M583.84 128.24h1.28",
    className: "boat-layout_svg__cls-1"
  })), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-691",
    d: "m601.27 100.64 69.83-2.95",
    className: "boat-layout_svg__cls-1"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-692",
    d: "m518.81 104.12 80.57-3.4",
    className: "boat-layout_svg__cls-1"
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__ARC-214",
    d: "M392.7 108.17c-1.13.05-2.2.52-3 1.33",
    className: "boat-layout_svg__cls-1"
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-693",
    d: "m376.05 123.27 13.65-13.78",
    className: "boat-layout_svg__cls-1"
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-694",
    d: "m373.14 132.97 2.91-9.7",
    className: "boat-layout_svg__cls-1"
  })), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-695",
    d: "m439.18 120.61 13.57-13.7",
    className: "boat-layout_svg__cls-1"
  })), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-696",
    d: "m439.18 120.61-2.7 9.4",
    className: "boat-layout_svg__cls-1"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-697",
    d: "m373.14 132.97 1.22.37",
    className: "boat-layout_svg__cls-1"
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-698",
    d: "m436.48 130.01 1.23.35",
    className: "boat-layout_svg__cls-1"
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__LINE-699",
    d: "m454.64 106.83 62.28-2.63",
    className: "boat-layout_svg__cls-1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "boat-layout_svg__Group_417-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_37-2",
    d: "M917.16.5v231.22",
    className: "boat-layout_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_41-2",
    d: "M911.37.5h11.58",
    className: "boat-layout_svg__cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "boat-layout_svg__Line_42-2",
    d: "M911.37 231.72h11.58",
    className: "boat-layout_svg__cls-3"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "boat-layout_svg__Height",
    className: "boat-layout_svg__cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "boat-layout_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.95 11.57v14.77h-1.93v-6.7h-7.52v6.7h-1.93V11.57h1.93v6.48h7.52v-6.48zm13.82 9.69h-9.28c.07 1.14.46 2.04 1.18 2.68s1.58.96 2.6.96c.83 0 1.53-.19 2.09-.58s.95-.91 1.18-1.56h2.08a4.97 4.97 0 0 1-1.86 2.72c-.93.7-2.09 1.05-3.47 1.05-1.1 0-2.09-.25-2.96-.74s-1.55-1.2-2.04-2.11c-.5-.91-.74-1.97-.74-3.17s.24-2.25.72-3.16c.48-.9 1.15-1.6 2.02-2.09s1.87-.73 3-.73 2.08.24 2.92.72c.85.48 1.5 1.14 1.96 1.98q.69 1.26.69 2.85 0 .555-.06 1.17Zm-2.41-3.46c-.33-.53-.77-.93-1.32-1.21-.56-.28-1.18-.41-1.86-.41q-1.455 0-2.49.93c-.68.62-1.08 1.48-1.18 2.58h7.33c0-.73-.16-1.37-.49-1.9Zm5.08-5.34c-.25-.25-.38-.56-.38-.93s.13-.68.38-.93c.26-.25.57-.38.93-.38s.65.13.9.38.37.57.37.93-.12.68-.37.93-.55.38-.9.38-.68-.13-.93-.38m1.87 2.27v11.61h-1.93V14.73zm10.71.47c.76.44 1.32.99 1.69 1.65v-2.12h1.95V26.6c0 1.06-.23 2-.68 2.83s-1.1 1.47-1.94 1.94-1.82.7-2.94.7c-1.52 0-2.8-.36-3.81-1.08s-1.62-1.7-1.8-2.95h1.91c.21.71.65 1.27 1.31 1.71.66.43 1.46.65 2.39.65 1.06 0 1.93-.33 2.6-1 .67-.66 1.01-1.6 1.01-2.8v-2.44c-.38.68-.95 1.24-1.7 1.7s-1.62.68-2.63.68-1.97-.25-2.81-.76-1.5-1.22-1.98-2.14-.72-1.96-.72-3.14.24-2.23.72-3.13 1.14-1.59 1.98-2.09c.84-.49 1.78-.74 2.81-.74s1.88.22 2.64.66m1.16 3.03c-.35-.65-.83-1.15-1.43-1.49-.6-.35-1.26-.52-1.98-.52s-1.38.17-1.97.51-1.07.83-1.42 1.48-.53 1.41-.53 2.29.18 1.66.53 2.32.83 1.16 1.42 1.51 1.25.52 1.97.52 1.38-.17 1.98-.52 1.08-.85 1.43-1.51.53-1.42.53-2.3-.18-1.64-.53-2.29m13.87-3.15c.71.37 1.26.94 1.66 1.68q.6 1.125.6 2.73v6.84h-1.91v-6.57c0-1.16-.29-2.04-.87-2.66-.58-.61-1.37-.92-2.37-.92s-1.82.32-2.43.95-.9 1.56-.9 2.78v6.42h-1.93V10.65h1.93v5.72c.38-.59.91-1.05 1.58-1.38.67-.32 1.42-.49 2.26-.49.88 0 1.67.19 2.37.56Zm7.78 1.24v6.84c0 .57.12.96.36 1.2.24.23.66.35 1.25.35h1.42v1.63h-1.74c-1.07 0-1.88-.25-2.41-.74-.54-.49-.81-1.31-.81-2.44v-6.84h-1.51v-1.59h1.51v-2.92h1.93v2.92h3.03v1.59z",
    className: "boat-layout_svg__cls-4"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "boat-layout_svg__Height-2",
    className: "boat-layout_svg__cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "boat-layout_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m429.4 343.52 5.17.1-.03 1.57-7.1-.14.29-14.77 1.93.04zm17.82-3.17-9.28-.18c.05 1.15.42 2.05 1.12 2.7s1.56 1 2.58 1.02c.83.02 1.53-.17 2.1-.54q.84-.57 1.2-1.53l2.08.04a4.97 4.97 0 0 1-1.92 2.69c-.94.68-2.11 1.01-3.49.98-1.1-.02-2.08-.29-2.94-.8a5.2 5.2 0 0 1-2-2.15c-.48-.92-.7-1.98-.68-3.18s.28-2.25.78-3.14 1.19-1.58 2.06-2.05c.88-.47 1.88-.7 3.01-.67q1.65.03 2.91.78c.84.5 1.48 1.17 1.92 2.02s.65 1.8.63 2.86c0 .37-.04.76-.09 1.16Zm-2.35-3.51c-.31-.54-.75-.95-1.3-1.23-.55-.29-1.17-.44-1.85-.45-.97-.02-1.81.28-2.51.88-.7.61-1.11 1.46-1.23 2.56l7.33.14c.01-.73-.14-1.37-.45-1.91Zm14.15-1.72c.86.87 1.27 2.11 1.24 3.72l-.13 6.84-1.91-.04.13-6.57c.02-1.16-.25-2.05-.82-2.68s-1.35-.95-2.36-.97c-1.02-.02-1.83.28-2.44.91s-.93 1.54-.95 2.76l-.12 6.42-1.93-.04.22-11.61 1.93.04-.03 1.65c.39-.59.92-1.03 1.58-1.35.66-.31 1.39-.46 2.18-.45 1.41.03 2.55.48 3.41 1.35Zm11.91-.37c.75.45 1.3 1.01 1.65 1.69l.04-2.12 1.95.04-.23 11.87c-.02 1.06-.27 2-.73 2.81a4.8 4.8 0 0 1-1.97 1.9c-.85.45-1.83.66-2.95.64-1.52-.03-2.79-.41-3.79-1.15s-1.58-1.73-1.74-2.98l1.91.04c.2.71.62 1.29 1.28 1.73.65.44 1.45.67 2.38.69 1.06.02 1.93-.29 2.61-.95.68-.65 1.04-1.58 1.06-2.78l.05-2.44c-.39.67-.97 1.22-1.73 1.66s-1.64.65-2.64.63c-1.03-.02-1.96-.29-2.79-.82a5.34 5.34 0 0 1-1.94-2.18q-.69-1.395-.66-3.15c.02-1.19.28-2.22.78-3.11s1.17-1.57 2.02-2.05q1.275-.72 2.82-.69c1 .02 1.88.26 2.63.71Zm1.1 3.05c-.34-.66-.81-1.16-1.4-1.52s-1.25-.54-1.97-.56c-.72-.01-1.38.14-1.98.47s-1.08.81-1.45 1.45-.56 1.4-.58 2.28c-.02.89.14 1.67.49 2.33.34.66.8 1.17 1.39 1.53s1.24.54 1.96.56c.72.01 1.38-.14 1.99-.48s1.09-.83 1.46-1.48c.36-.65.56-1.41.57-2.29.02-.88-.15-1.64-.49-2.3Zm8.13-1.75-.13 6.84c-.01.56.1.97.34 1.2.24.24.65.36 1.24.37l1.42.03-.03 1.63-1.74-.03c-1.07-.02-1.87-.28-2.4-.79-.53-.5-.78-1.32-.76-2.45l.13-6.84-1.51-.03.03-1.59 1.51.03.06-2.92 1.93.04-.06 2.92 3.03.06-.03 1.59zm13.52-.98c.7.39 1.24.96 1.63 1.72s.57 1.67.55 2.75l-.13 6.84-1.91-.04.13-6.57c.02-1.16-.25-2.05-.82-2.68s-1.35-.95-2.35-.97c-1.02-.02-1.83.28-2.44.91s-.93 1.54-.95 2.76l-.13 6.42-1.93-.04.3-15.68 1.93.04-.11 5.72c.39-.58.93-1.03 1.61-1.35.68-.31 1.43-.46 2.27-.44.88.02 1.66.22 2.36.61Z",
    className: "boat-layout_svg__cls-4"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "boat-layout_svg__Height-3",
    className: "boat-layout_svg__cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "boat-layout_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M841.15 434.39c.44.36.78.81 1.03 1.34s.37 1.09.36 1.68c-.01.75-.22 1.42-.61 2.01-.4.59-.96 1.06-1.69 1.39s-1.59.49-2.58.47l-5.51-.11.29-14.77 5.3.1c1 .02 1.85.2 2.55.55s1.22.81 1.57 1.38c.34.57.5 1.21.49 1.92-.02.88-.26 1.59-.75 2.16-.48.56-1.12.97-1.9 1.2.53.09 1.02.32 1.46.68Zm-1.37 4.66c.55-.44.83-1.06.84-1.87.01-.82-.26-1.47-.81-1.96-.56-.48-1.31-.74-2.26-.75l-3.35-.06-.1 5.21 3.41.07c.96.02 1.71-.19 2.26-.63Zm-5.54-6.23 3.24.06c.9.02 1.61-.18 2.11-.6.5-.41.76-1 .78-1.74s-.22-1.34-.71-1.77c-.48-.43-1.19-.66-2.13-.68l-3.2-.06zm21.52 3.72-9.28-.18c.05 1.15.42 2.05 1.12 2.7s1.56 1 2.58 1.02c.83.02 1.53-.17 2.1-.54s.97-.89 1.21-1.53l2.08.04a4.97 4.97 0 0 1-1.92 2.69c-.95.68-2.11 1.01-3.49.98-1.1-.02-2.08-.29-2.94-.8s-1.53-1.23-2.01-2.15-.7-1.98-.68-3.18.28-2.25.78-3.14 1.19-1.58 2.06-2.05c.88-.47 1.88-.7 3.01-.67q1.65.03 2.91.78c.84.5 1.48 1.17 1.92 2.02s.65 1.8.63 2.86c0 .37-.04.76-.09 1.16Zm-2.35-3.51c-.31-.54-.75-.95-1.3-1.23s-1.17-.44-1.84-.45c-.97-.02-1.81.28-2.51.88-.7.61-1.11 1.46-1.23 2.56l7.33.14c.01-.73-.14-1.37-.45-1.91Zm5.03-.32c.5-.89 1.17-1.57 2.02-2.05q1.275-.72 2.82-.69c1.02.02 1.9.26 2.64.71s1.29 1.01 1.64 1.69l.04-2.12 1.95.04-.22 11.61-1.95-.04.04-2.16q-.585 1.005-1.74 1.65c-.77.43-1.65.64-2.65.62-1.03-.02-1.96-.29-2.78-.82-.83-.53-1.47-1.25-1.93-2.18s-.68-1.98-.66-3.15c.02-1.19.28-2.22.78-3.11m8.56 1.02c-.34-.66-.81-1.17-1.4-1.52-.6-.36-1.25-.54-1.97-.56-.72-.01-1.38.14-1.98.47s-1.08.81-1.45 1.45-.56 1.4-.58 2.28c-.02.89.14 1.67.49 2.33.34.66.8 1.17 1.39 1.53s1.24.54 1.96.56c.72.01 1.38-.15 1.99-.48.61-.34 1.1-.83 1.46-1.48s.56-1.41.57-2.29c.02-.88-.15-1.64-.49-2.3Zm22.19-2.72c.7.39 1.24.96 1.64 1.72s.58 1.67.56 2.75l-.13 6.84-1.91-.04.13-6.57c.02-1.16-.25-2.05-.81-2.68-.56-.62-1.33-.95-2.3-.97-1-.02-1.81.29-2.41.92s-.92 1.56-.94 2.77l-.12 6.4-1.91-.04.13-6.57c.02-1.16-.25-2.05-.8-2.68-.56-.63-1.33-.95-2.31-.97-1-.02-1.81.29-2.41.92s-.92 1.56-.94 2.77l-.12 6.4-1.93-.04.22-11.61 1.93.04-.03 1.67c.39-.6.92-1.06 1.56-1.37.65-.31 1.36-.46 2.14-.45.97.02 1.83.25 2.57.71s1.29 1.11 1.64 1.96c.34-.81.89-1.44 1.65-1.88s1.6-.65 2.51-.63c.9.02 1.71.22 2.41.61Z",
    className: "boat-layout_svg__cls-4"
  })))));
};
export default SvgBoatLayout;